// import { useState, useEffect } from 'react';
// import { Plus, Edit2, Trash2, RefreshCcw, Save, X, Search, Filter, AlertCircle, CheckCircle2, MapPin, Building, FileText, Calendar } from 'lucide-react';

// const VendorCreditManagement = () => {
//     const [credits, setCredits] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isLoadingVendor, setIsLoadingVendor] = useState(false);
//     const [isLoadingBills, setIsLoadingBills] = useState(false);
//     const [showForm, setShowForm] = useState(false);
//     const [editingCredit, setEditingCredit] = useState(null);
//     const [pagination, setPagination] = useState({
//         page: 1,
//         limit: 10,
//         total: 0,
//         totalPages: 0
//     });
//     const [searchTerm, setSearchTerm] = useState('');
//     const [filter, setFilter] = useState('all');
//     const [vendorSuggestions, setVendorSuggestions] = useState([]);
//     const [showVendorSuggestions, setShowVendorSuggestions] = useState(false);
//     const [vendorBills, setVendorBills] = useState([]);
//     const [showBillSelector, setShowBillSelector] = useState(false);

//     const [formData, setFormData] = useState({
//         vendor_name: '',
//         bill_number: '',
//         bill_date: '',
//         balance: '',
//         debit_note_amount: '',
//         vendor_id: '',
//         currency_id: '3000000000083',
//         vat_treatment: '',
//         vendor_credit_number: '',
//         gst_treatment: 'business_gst',
//         tax_treatment: 'vat_registered',
//         gst_no: '',
//         source_of_supply: 'TN',
//         destination_of_supply: 'TN',
//         place_of_supply: 'DU',
//         pricebook_id: '',
//         reference_number: '',
//         is_update_customer: false,
//         exchange_rate: 1,
//         is_inclusive_tax: false,
//         location_id: '',
//         line_items: [{
//             item_id: '',
//             name: '',
//             description: '',
//             quantity: 1,
//             unit: 'Nos',
//             rate: 0,
//             tax_id: '',
//             hsn_or_sac: '',
//             cgst_rate: 0,
//             sgst_rate: 0,
//             igst_rate: 0,
//             total_tax: 0
//         }],
//         notes: '',
//         custom_fields: [],
//         company_id: '1',
//         autoSync: false,
//         zoho_bill_id: '',
//         selected_bill: null
//     });

//     // Organization state
//     const [currentOrganization, setCurrentOrganization] = useState({
//         organization_id: '',
//         name: ''
//     });

//     const API_BASE_URL = 'https://api.zapbooksai.subraps.com/api';

//     // Get authentication headers
//     const getAuthHeaders = () => {
//         const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
//         return {
//             'Content-Type': 'application/json',
//             ...(token && { 'Authorization': `Bearer ${token}` })
//         };
//     };

//     // Fetch current organization
//     const fetchCurrentOrganization = async () => {
//         try {
//             console.log('🔍 Fetching current organization...');
//             const response = await fetch(`${API_BASE_URL}/token/status`, {
//                 headers: getAuthHeaders()
//             });
//             const result = await response.json();

//             if (result.success && result.data.current_organization) {
//                 const org = result.data.current_organization;
//                 console.log('✅ Current organization fetched:', org);
//                 setCurrentOrganization(org);
//                 return org.organization_id;
//             } else {
//                 console.error('❌ No current organization found');
//                 throw new Error('No current organization found');
//             }
//         } catch (error) {
//             console.error('❌ Error fetching current organization:', error);
//         }
//     };

//     // Helper function to extract state code from GST number
//     const getStateFromGST = (gstNumber) => {
//         if (!gstNumber || gstNumber.length < 2) return null;

//         const stateCode = gstNumber.substring(0, 2);
//         const gstStateMapping = {
//             '01': 'Jammu & Kashmir', '02': 'Himachal Pradesh', '03': 'Punjab', '04': 'Chandigarh',
//             '05': 'Uttarakhand', '06': 'Haryana', '07': 'Delhi', '08': 'Rajasthan',
//             '09': 'Uttar Pradesh', '10': 'Bihar', '11': 'Sikkim', '12': 'Arunachal Pradesh',
//             '13': 'Nagaland', '14': 'Manipur', '15': 'Mizoram', '16': 'Tripura',
//             '17': 'Meghalaya', '18': 'Assam', '19': 'West Bengal', '20': 'Jharkhand',
//             '21': 'Odisha', '22': 'Chhattisgarh', '23': 'Madhya Pradesh', '24': 'Gujarat',
//             '25': 'Daman & Diu', '26': 'Dadra & Nagar Haveli', '27': 'Maharashtra',
//             '28': 'Andhra Pradesh', '29': 'Karnataka', '30': 'Goa', '31': 'Lakshadweep',
//             '32': 'Kerala', '33': 'Tamil Nadu', '34': 'Puducherry', '35': 'Andaman & Nicobar',
//             '36': 'Telangana', '37': 'Andhra Pradesh', '38': 'Ladakh'
//         };

//         return gstStateMapping[stateCode] || `State Code: ${stateCode}`;
//     };

//     // Determine transaction type based on GST states
//     const getTransactionType = (vendorGST, orgState = 'TN') => {
//         if (!vendorGST) return { type: 'Unknown', taxType: 'GST' };

//         const vendorStateCode = vendorGST.substring(0, 2);
//         const orgStateCode = orgState === 'TN' ? '33' : ''; // Default to TN

//         const isIntraState = vendorStateCode === orgStateCode;

//         return {
//             type: isIntraState ? 'Intra-State' : 'Inter-State',
//             taxType: isIntraState ? 'CGST+SGST' : 'IGST',
//             color: isIntraState ? 'text-green-600' : 'text-blue-600'
//         };
//     };

//     // Search vendors in Zoho Books
//     const searchVendors = async (searchTerm) => {
//         if (!searchTerm || searchTerm.length < 2) {
//             setVendorSuggestions([]);
//             return;
//         }

//         try {
//             setIsLoadingVendor(true);
//             console.log('🔍 Searching vendors for term:', searchTerm);
//             console.log('🏢 Using organization ID:', currentOrganization?.organization_id);

//             // Include organization_id in the search request
//             const searchParams = new URLSearchParams({
//                 query: searchTerm
//             });

//             if (currentOrganization?.organization_id) {
//                 searchParams.append('organization_id', currentOrganization.organization_id);
//             }

//             const response = await fetch(`${API_BASE_URL}/zoho/vendors/search?${searchParams}`, {
//                 headers: getAuthHeaders()
//             });

//             console.log('📡 Vendor search response status:', response.status);

//             const result = await response.json();
//             console.log('📊 Vendor search result:', result);

//             if (result.success && result.data.vendors) {
//                 console.log('✅ Found vendors:', result.data.vendors.length);
//                 console.log('📋 First vendor data:', result.data.vendors[0]);
//                 console.log('🏢 Search performed in org:', result.data.debug?.organizationId);

//                 setVendorSuggestions(result.data.vendors.slice(0, 10));
//             } else {
//                 console.warn('⚠️ No vendors found or API error:', result.message);
//                 console.log('🏢 Organization used:', result.data?.debug?.organizationId);
//                 setVendorSuggestions([]);
//             }
//         } catch (error) {
//             console.error('❌ Error searching vendors:', error);
//             setVendorSuggestions([]);
//         } finally {
//             setIsLoadingVendor(false);
//         }
//     };

//     // Get vendor details from Zoho Books
//     const getVendorDetails = async (vendorId) => {
//         try {
//             setIsLoadingVendor(true);
//             console.log('🔍 Fetching vendor details for ID:', vendorId);
//             console.log('🏢 Using organization ID:', currentOrganization?.organization_id);

//             // Include organization_id in the vendor details request
//             const detailsParams = new URLSearchParams();
//             if (currentOrganization?.organization_id) {
//                 detailsParams.append('organization_id', currentOrganization.organization_id);
//             }

//             const response = await fetch(`${API_BASE_URL}/zoho/vendors/${vendorId}?${detailsParams}`, {
//                 headers: getAuthHeaders()
//             });

//             console.log('📡 Vendor details response status:', response.status);

//             const result = await response.json();
//             console.log('📊 Vendor details result:', result);

//             if (result.success && result.data.vendor) {
//                 console.log('✅ Vendor details fetched successfully:', result.data.vendor);
//                 console.log('🏢 Details fetched from org:', result.data.debug?.organizationId);
//                 return result.data.vendor;
//             } else {
//                 console.warn('⚠️ Failed to fetch vendor details:', result.message);
//                 console.log('🏢 Organization used:', result.data?.debug?.organizationId);
//             }
//             return null;
//         } catch (error) {
//             console.error('❌ Error fetching vendor details:', error);
//             return null;
//         } finally {
//             setIsLoadingVendor(false);
//         }
//     };

//     // Replace your fetchVendorBills function in the frontend
//     const fetchVendorBills = async (vendorId) => {
//         if (!vendorId) return;

//         try {
//             setIsLoadingBills(true);
//             console.log('🔍 Fetching bills for vendor ID:', vendorId);
//             console.log('🏢 Using organization ID:', currentOrganization?.organization_id);

//             // Include organization_id in the bills request
//             const billsParams = new URLSearchParams();
//             if (currentOrganization?.organization_id) {
//                 billsParams.append('organization_id', currentOrganization.organization_id);
//             }

//             const response = await fetch(`${API_BASE_URL}/zoho/vendors/${vendorId}/bills?${billsParams}`, {
//                 headers: getAuthHeaders()
//             });

//             console.log('📡 Vendor bills response status:', response.status);

//             const result = await response.json();
//             console.log('📊 Vendor bills result:', result);

//             if (result.success && result.data.bills) {
//                 console.log('✅ Found bills:', result.data.bills.length);
//                 console.log('📋 Bills data:', result.data.bills);
//                 setVendorBills(result.data.bills);
//                 return result.data.bills;
//             } else {
//                 console.warn('⚠️ No bills found or API error:', result.message);
//                 setVendorBills([]);
//                 return [];
//             }
//         } catch (error) {
//             console.error('❌ Error fetching vendor bills:', error);
//             setVendorBills([]);
//             return [];
//         } finally {
//             setIsLoadingBills(false);
//         }
//     };

//     // Handle vendor selection with enhanced state management
//     const handleVendorSelect = async (vendor) => {
//         console.log('🔄 Vendor selected:', vendor);

//         // IMMEDIATE: Set basic vendor info first
//         setFormData(prev => ({
//             ...prev,
//             vendor_name: vendor.vendor_name,
//             vendor_id: vendor.vendor_id
//         }));

//         // Clear suggestions immediately
//         setShowVendorSuggestions(false);
//         setVendorSuggestions([]);

//         try {
//             // Get detailed vendor information
//             setIsLoadingVendor(true);
//             const vendorDetails = await getVendorDetails(vendor.vendor_id);

//             if (vendorDetails) {
//                 console.log('✅ Vendor details fetched:', vendorDetails);

//                 // Extract state from GST number
//                 let destinationState = null;
//                 let placeOfSupply = null;

//                 if (vendorDetails.gst_no) {
//                     const gstStateCode = vendorDetails.gst_no.substring(0, 2);
//                     // Convert GST state code to actual state code for place of supply
//                     const stateCodeMapping = {
//                         '33': 'TN', '24': 'GJ', '27': 'MH', '29': 'KA', '07': 'DL',
//                         '32': 'KL', '28': 'AP', '36': 'TG', '19': 'WB', '09': 'UP'
//                         // Add more mappings as needed
//                     };
//                     destinationState = stateCodeMapping[gstStateCode] || gstStateCode;
//                     placeOfSupply = destinationState;
//                 }

//                 // ENHANCED: Update form with all vendor details
//                 setFormData(prev => ({
//                     ...prev,
//                     vendor_name: vendorDetails.vendor_name,
//                     vendor_id: vendorDetails.vendor_id, // Ensure this is set again
//                     gst_no: vendorDetails.gst_no || '',
//                     gst_treatment: vendorDetails.gst_treatment || 'business_gst',
//                     tax_treatment: vendorDetails.tax_treatment || 'vat_registered',
//                     place_of_supply: placeOfSupply || vendorDetails.place_of_supply || prev.place_of_supply,
//                     source_of_supply: 'TN', // Organization state
//                     destination_of_supply: destinationState || vendorDetails.billing_address?.state_code || prev.destination_of_supply,
//                     currency_id: vendorDetails.currency_id || prev.currency_id
//                 }));

//                 console.log('✅ Form updated with vendor details');
//             } else {
//                 console.warn('⚠️ No vendor details returned from API');
//             }

//             // Fetch vendor bills after vendor selection
//             await fetchVendorBills(vendor.vendor_id);

//         } catch (error) {
//             console.error('❌ Error in handleVendorSelect:', error);
//             // Keep the basic vendor info even if detailed fetch fails
//             setFormData(prev => ({
//                 ...prev,
//                 vendor_name: vendor.vendor_name,
//                 vendor_id: vendor.vendor_id
//             }));
//         } finally {
//             setIsLoadingVendor(false);
//         }
//     };

//     // NEW: Handle bill selection
//     const handleBillSelect = (bill) => {
//         setFormData(prev => ({
//             ...prev,
//             bill_number: bill.bill_number,
//             bill_date: bill.date,
//             balance: bill.balance || bill.total,
//             zoho_bill_id: bill.bill_id,
//             selected_bill: bill
//         }));
//         setShowBillSelector(false);
//     };

//     // Enhanced line item handling for existing data
//     const parseLineItemsFromDatabase = (lineItemsData) => {
//         if (!lineItemsData) return getDefaultLineItem();

//         try {
//             let parsedItems = [];

//             console.log('🔍 Raw line items data:', lineItemsData);

//             if (typeof lineItemsData === 'string') {
//                 try {
//                     parsedItems = JSON.parse(lineItemsData);
//                 } catch (parseError) {
//                     console.error('❌ JSON parse error:', parseError);
//                     return getDefaultLineItem();
//                 }
//             } else if (Array.isArray(lineItemsData)) {
//                 parsedItems = lineItemsData;
//             } else if (typeof lineItemsData === 'object') {
//                 parsedItems = [lineItemsData];
//             }

//             if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
//                 return getDefaultLineItem();
//             }

//             const formattedItems = parsedItems.map((item) => ({
//                 item_id: item.item_id || '',
//                 name: item.name || '',
//                 description: item.description || item.name || '',
//                 quantity: parseFloat(item.quantity) || 1,
//                 unit: item.unit || 'Nos',
//                 rate: parseFloat(item.rate) || 0,
//                 tax_id: item.tax_id || '',
//                 hsn_or_sac: item.hsn_or_sac || '',
//                 cgst_rate: parseFloat(item.cgst_rate) || 0,
//                 sgst_rate: parseFloat(item.sgst_rate) || 0,
//                 igst_rate: parseFloat(item.igst_rate) || 0,
//                 total_tax: parseFloat(item.total_tax) || 0
//             }));

//             return formattedItems;

//         } catch (error) {
//             console.error('❌ Error parsing line items:', error);
//             return getDefaultLineItem();
//         }
//     };

//     const getDefaultLineItem = () => [{
//         item_id: '',
//         name: '',
//         description: '',
//         quantity: 1,
//         unit: 'Nos',
//         rate: 0,
//         tax_id: '',
//         hsn_or_sac: '',
//         cgst_rate: 0,
//         sgst_rate: 0,
//         igst_rate: 0,
//         total_tax: 0
//     }];

//     // Calculate line item total including tax
//     const calculateLineItemTotal = (item) => {
//         const subtotal = (parseFloat(item.quantity) || 0) * (parseFloat(item.rate) || 0);
//         const totalTax = parseFloat(item.total_tax) || 0;
//         return subtotal + totalTax;
//     };

//     // Initialize component
//     useEffect(() => {
//         const initializeComponent = async () => {
//             try {
//                 await fetchCurrentOrganization();
//             } catch (error) {
//                 console.error('Failed to initialize component:', error);
//             }
//         };

//         initializeComponent();
//     }, []);

//     useEffect(() => {
//         if (currentOrganization?.organization_id) {
//             fetchCredits();
//         }
//     }, [pagination.page, searchTerm, filter, currentOrganization?.organization_id]);

//     const fetchCredits = async () => {
//         if (!currentOrganization?.organization_id) {
//             console.log('❌ No organization ID available, skipping load');
//             return;
//         }
//         setIsLoading(true);
//         try {
//             const params = new URLSearchParams({
//                 page: pagination.page,
//                 limit: pagination.limit,
//                 company_id: currentOrganization?.organization_id
//             });

//             const response = await fetch(`${API_BASE_URL}/vendor-credits?${params}`, {
//                 headers: getAuthHeaders()
//             });
//             const result = await response.json();

//             if (result.success) {
//                 setCredits(result.data.credits);
//                 setPagination(prev => ({
//                     ...prev,
//                     total: result.data.total,
//                     totalPages: result.data.totalPages
//                 }));
//             }
//         } catch (error) {
//             console.error('Error fetching credits:', error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         try {
//             // FIXED: Remove UI-only fields before sending to backend
//             const { selected_bill, ...formDataToSend } = formData;

//             const formattedData = {
//                 ...formDataToSend,
//                 bill_date: formDataToSend.bill_date || null,
//                 company_id: currentOrganization?.organization_id
//             };

//             // Remove any undefined or empty string values
//             Object.keys(formattedData).forEach(key => {
//                 if (formattedData[key] === '' || formattedData[key] === undefined) {
//                     formattedData[key] = null;
//                 }
//             });

//             console.log('📤 Sending formatted data:', formattedData);

//             const url = editingCredit ? `${API_BASE_URL}/vendor-credits/${editingCredit.id}` : `${API_BASE_URL}/vendor-credits`;
//             const method = editingCredit ? 'PUT' : 'POST';

//             const response = await fetch(url, {
//                 method,
//                 headers: getAuthHeaders(),
//                 body: JSON.stringify(formattedData),
//             });

//             const result = await response.json();

//             if (result.success) {
//                 setShowForm(false);
//                 setEditingCredit(null);
//                 resetForm();
//                 fetchCredits();
//                 alert(editingCredit ? 'Credit updated successfully!' : 'Credit created successfully!');
//             } else {
//                 alert('Error: ' + result.message);
//             }
//         } catch (error) {
//             console.error('Error saving credit:', error);
//             alert('Error saving credit');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleEdit = async (credit) => {
//         setEditingCredit(credit);
//         setIsLoadingVendor(true);

//         try {
//             // Get fresh credit data
//             let freshCredit = credit;
//             try {
//                 const creditResponse = await fetch(`${API_BASE_URL}/vendor-credits/${credit.id}`, {
//                     headers: getAuthHeaders()
//                 });
//                 if (creditResponse.ok) {
//                     const creditResult = await creditResponse.json();
//                     if (creditResult.success) {
//                         freshCredit = creditResult.data;
//                     }
//                 }
//             } catch (creditError) {
//                 console.warn('Could not fetch fresh credit data:', creditError);
//             }

//             // Convert DB date to local date string
//             const dbDate = freshCredit.bill_date ? new Date(freshCredit.bill_date) : null;
//             const localDate = dbDate ?
//                 `${dbDate.getFullYear()}-${String(dbDate.getMonth() + 1).padStart(2, '0')}-${String(dbDate.getDate()).padStart(2, '0')}` :
//                 '';

//             // Parse line items
//             const parsedLineItems = parseLineItemsFromDatabase(freshCredit.line_items);

//             // Set initial form data
//             setFormData({
//                 ...freshCredit,
//                 bill_date: localDate,
//                 line_items: parsedLineItems,
//                 autoSync: false,
//                 company_id: currentOrganization?.organization_id,
//                 selected_bill: freshCredit.zoho_bill_id ? {
//                     bill_id: freshCredit.zoho_bill_id,
//                     bill_number: freshCredit.bill_number
//                 } : null
//             });

//             // Update vendor details if vendor_id exists
//             if (freshCredit.vendor_id) {
//                 console.log('🔄 Refreshing vendor details for ID:', freshCredit.vendor_id);

//                 // Fetch vendor bills
//                 await fetchVendorBills(freshCredit.vendor_id);

//                 const vendorDetails = await getVendorDetails(freshCredit.vendor_id);

//                 if (vendorDetails) {
//                     // Extract state from GST number for proper supply places
//                     let destinationState = null;
//                     let placeOfSupply = null;

//                     if (vendorDetails.gst_no) {
//                         const gstStateCode = vendorDetails.gst_no.substring(0, 2);
//                         const stateCodeMapping = {
//                             '33': 'TN', '24': 'GJ', '27': 'MH', '29': 'KA', '07': 'DL',
//                             '32': 'KL', '28': 'AP', '36': 'TG', '19': 'WB', '09': 'UP'
//                         };
//                         destinationState = stateCodeMapping[gstStateCode] || gstStateCode;
//                         placeOfSupply = destinationState;
//                     }

//                     setFormData(prev => ({
//                         ...prev,
//                         vendor_name: vendorDetails.vendor_name,
//                         gst_no: vendorDetails.gst_no || prev.gst_no,
//                         gst_treatment: vendorDetails.gst_treatment || prev.gst_treatment,
//                         tax_treatment: vendorDetails.tax_treatment || prev.tax_treatment,
//                         place_of_supply: placeOfSupply || vendorDetails.place_of_supply || prev.place_of_supply,
//                         source_of_supply: 'TN', // Organization state
//                         destination_of_supply: destinationState || vendorDetails.billing_address?.state_code || prev.destination_of_supply,
//                         currency_id: vendorDetails.currency_id || prev.currency_id
//                     }));
//                 }
//             }

//         } catch (error) {
//             console.error('Error in handleEdit:', error);
//         } finally {
//             setIsLoadingVendor(false);
//             setShowForm(true);
//         }
//     };

//     const handleDelete = async (id) => {
//         if (window.confirm('Are you sure you want to delete this credit?')) {
//             try {
//                 const response = await fetch(`${API_BASE_URL}/vendor-credits/${id}`, {
//                     method: 'DELETE',
//                     headers: getAuthHeaders()
//                 });

//                 const result = await response.json();

//                 if (result.success) {
//                     fetchCredits();
//                     alert('Credit deleted successfully!');
//                 } else {
//                     alert('Error: ' + result.message);
//                 }
//             } catch (error) {
//                 console.error('Error deleting credit:', error);
//                 alert('Error deleting credit');
//             }
//         }
//     };

//     // REPLACE your handleSync function in the frontend with this fixed version

//     const handleSync = async (id) => {
//         try {
//             // Include organization_id in the sync request
//             const syncPayload = {
//                 organization_id: currentOrganization?.organization_id
//             };

//             console.log('🔄 Syncing with organization ID:', currentOrganization?.organization_id);

//             const response = await fetch(`${API_BASE_URL}/vendor-credits/${id}/sync`, {
//                 method: 'POST',
//                 headers: getAuthHeaders(),
//                 body: JSON.stringify(syncPayload)
//             });

//             const result = await response.json();

//             if (result.success) {
//                 fetchCredits();
//                 alert('Credit synced to Zoho Books successfully!');
//                 console.log('✅ Sync result:', result.data);
//             } else {
//                 alert('Sync error: ' + result.message);
//                 console.error('❌ Sync error:', result.message);
//             }
//         } catch (error) {
//             console.error('Error syncing credit:', error);
//             alert('Error syncing credit');
//         }
//     };

//     const resetForm = () => {
//         setFormData({
//             vendor_name: '',
//             bill_number: '',
//             bill_date: '',
//             balance: '',
//             debit_note_amount: '',
//             vendor_id: '',
//             currency_id: '3000000000083',
//             vat_treatment: '',
//             vendor_credit_number: '',
//             gst_treatment: 'business_gst',
//             tax_treatment: 'vat_registered',
//             gst_no: '',
//             source_of_supply: 'TN',
//             destination_of_supply: 'TN',
//             place_of_supply: 'DU',
//             pricebook_id: '',
//             reference_number: '',
//             is_update_customer: false,
//             exchange_rate: 1,
//             is_inclusive_tax: false,
//             location_id: '',
//             line_items: getDefaultLineItem(),
//             notes: '',
//             custom_fields: [],
//             company_id: currentOrganization?.organization_id || '1',
//             autoSync: false,
//             zoho_bill_id: '',
//             selected_bill: null
//         });
//         setVendorSuggestions([]);
//         setShowVendorSuggestions(false);
//         setVendorBills([]);
//         setShowBillSelector(false);
//     };

//     const addLineItem = () => {
//         setFormData(prev => ({
//             ...prev,
//             line_items: [...prev.line_items, {
//                 item_id: '',
//                 name: '',
//                 description: '',
//                 quantity: 1,
//                 unit: 'Nos',
//                 rate: 0,
//                 tax_id: '',
//                 hsn_or_sac: '',
//                 cgst_rate: 0,
//                 sgst_rate: 0,
//                 igst_rate: 0,
//                 total_tax: 0
//             }]
//         }));
//     };

//     const removeLineItem = (index) => {
//         setFormData(prev => ({
//             ...prev,
//             line_items: prev.line_items.filter((_, i) => i !== index)
//         }));
//     };

//     const updateLineItem = (index, field, value) => {
//         setFormData(prev => ({
//             ...prev,
//             line_items: prev.line_items.map((item, i) =>
//                 i === index ? { ...item, [field]: value } : item
//             )
//         }));
//     };

//     const getSyncStatusBadge = (status) => {
//         const badges = {
//             'pending': 'bg-yellow-100 text-yellow-800',
//             'synced': 'bg-green-100 text-green-800',
//             'error': 'bg-red-100 text-red-800'
//         };
//         return badges[status] || 'bg-gray-100 text-gray-800';
//     };

//     const filteredCredits = credits.filter(credit => {
//         const matchesSearch = credit.vendor_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             credit.bill_number.toLowerCase().includes(searchTerm.toLowerCase());

//         if (filter === 'all') return matchesSearch;
//         return matchesSearch && credit.sync_status === filter;
//     });

//     return (
//         <div className="max-w-7xl mx-auto p-6">
//             <div className="flex justify-between items-center mb-6">
//                 <div>
//                     <h1 className="text-3xl font-bold text-gray-900">Vendor Credit Management</h1>
//                     {/* NEW: Display current organization */}
//                     {currentOrganization?.name && (
//                         <div className="flex items-center gap-2 mt-2">
//                             <Building className="w-4 h-4 text-blue-600" />
//                             <span className="text-sm text-gray-600">
//                                 Organization: <span className="font-medium text-blue-600">{currentOrganization.name}</span>
//                             </span>
//                         </div>
//                     )}
//                 </div>
//                 <button
//                     onClick={() => {
//                         resetForm();
//                         setShowForm(true);
//                     }}
//                     className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
//                 >
//                     <Plus size={20} />
//                     Add Credit
//                 </button>
//             </div>

//             {/* Search and Filter */}
//             <div className="mb-6 flex gap-4">
//                 <div className="flex-1 relative">
//                     <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                     <input
//                         type="text"
//                         placeholder="Search by vendor name or bill number..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     />
//                 </div>
//                 <div className="flex items-center gap-2">
//                     <Filter size={20} className="text-gray-400" />
//                     <select
//                         value={filter}
//                         onChange={(e) => setFilter(e.target.value)}
//                         className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     >
//                         <option value="all">All Status</option>
//                         <option value="pending">Pending</option>
//                         <option value="synced">Synced</option>
//                         <option value="error">Error</option>
//                     </select>
//                 </div>
//             </div>

//             {/* Credits Table */}
//             <div className="bg-white rounded-lg shadow-md overflow-hidden">
//                 <div className="overflow-x-auto">
//                     <table className="w-full">
//                         <thead className="bg-gray-50">
//                             <tr>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vendor</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bill Info</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tax Info</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className="bg-white divide-y divide-gray-200">
//                             {isLoading ? (
//                                 <tr>
//                                     <td colSpan="7" className="px-6 py-4 text-center text-gray-500">Loading...</td>
//                                 </tr>
//                             ) : filteredCredits.length === 0 ? (
//                                 <tr>
//                                     <td colSpan="7" className="px-6 py-4 text-center text-gray-500">No credits found</td>
//                                 </tr>
//                             ) : (
//                                 filteredCredits.map((credit) => {
//                                     const transactionInfo = getTransactionType(credit.gst_no, 'TN');
//                                     const vendorState = getStateFromGST(credit.gst_no);

//                                     return (
//                                         <tr key={credit.id} className="hover:bg-gray-50">
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <div className="flex items-center">
//                                                     <div>
//                                                         <div className="text-sm font-medium text-gray-900">{credit.vendor_name}</div>
//                                                         <div className="flex items-center gap-1 text-xs text-gray-500">
//                                                             {credit.vendor_id ? (
//                                                                 <>
//                                                                     <CheckCircle2 size={12} className="text-green-500" />
//                                                                     <span>ID: {credit.vendor_id}</span>
//                                                                 </>
//                                                             ) : (
//                                                                 <>
//                                                                     <AlertCircle size={12} className="text-yellow-500" />
//                                                                     <span className="text-yellow-600">Missing ID</span>
//                                                                 </>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <div className="text-sm text-gray-900">{credit.bill_number}</div>
//                                                 {credit.zoho_bill_id && (
//                                                     <div className="flex items-center gap-1 text-xs text-green-600">
//                                                         <FileText size={12} />
//                                                         <span>Linked to Zoho</span>
//                                                     </div>
//                                                 )}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                                                 {credit.bill_date ? new Date(credit.bill_date).toLocaleDateString() : '-'}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                                                 ₹ {parseFloat(credit.debit_note_amount || 0).toFixed(2)}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <div className="text-sm">
//                                                     {credit.gst_no ? (
//                                                         <div>
//                                                             <div className="flex items-center gap-1">
//                                                                 <Building size={12} className="text-gray-400" />
//                                                                 <span className="text-xs font-mono">{credit.gst_no}</span>
//                                                             </div>
//                                                             <div className="flex items-center gap-1 mt-1">
//                                                                 <MapPin size={12} className="text-gray-400" />
//                                                                 <span className="text-xs text-gray-600">{vendorState}</span>
//                                                             </div>
//                                                             <div className={`text-xs font-medium mt-1 ${transactionInfo.color}`}>
//                                                                 {transactionInfo.type} ({transactionInfo.taxType})
//                                                             </div>
//                                                         </div>
//                                                     ) : (
//                                                         <div className="flex items-center gap-1">
//                                                             <AlertCircle size={12} className="text-yellow-500" />
//                                                             <span className="text-xs text-yellow-600">No GST Info</span>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getSyncStatusBadge(credit.sync_status)}`}>
//                                                     {credit.sync_status}
//                                                 </span>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                                                 <div className="flex gap-2">
//                                                     <button
//                                                         onClick={() => handleEdit(credit)}
//                                                         disabled={credit.sync_status === 'synced'}
//                                                         className={`${credit.sync_status === 'synced'
//                                                             ? 'text-gray-400 cursor-not-allowed'
//                                                             : 'text-blue-600 hover:text-blue-900'}`}
//                                                         title={credit.sync_status === 'synced' ? "Cannot edit synced credit" : "Edit"}
//                                                     >
//                                                         <Edit2 size={16} />
//                                                     </button>
//                                                     <button
//                                                         onClick={() => handleSync(credit.id)}
//                                                         disabled={credit.sync_status === 'synced'}
//                                                         className={`${credit.sync_status === 'synced'
//                                                             ? 'text-gray-400 cursor-not-allowed'
//                                                             : 'text-green-600 hover:text-green-900'}`}
//                                                         title={credit.sync_status === 'synced' ? "Already synced to Zoho" : "Sync to Zoho"}
//                                                     >
//                                                         <RefreshCcw size={16} />
//                                                     </button>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     );
//                                 })
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             {/* Pagination */}
//             <div className="mt-6 flex justify-between items-center">
//                 <div className="text-sm text-gray-700">
//                     Showing {(pagination.page - 1) * pagination.limit + 1} to{' '}
//                     {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
//                 </div>
//                 <div className="flex gap-2">
//                     <button
//                         onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
//                         disabled={pagination.page === 1}
//                         className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                         Previous
//                     </button>
//                     <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded">
//                         {pagination.page} / {pagination.totalPages}
//                     </span>
//                     <button
//                         onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
//                         disabled={pagination.page === pagination.totalPages}
//                         className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                         Next
//                     </button>
//                 </div>
//             </div>

//             {/* Form Modal */}
//             {showForm && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
//                         <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
//                             <div>
//                                 <h2 className="text-xl font-semibold">
//                                     {editingCredit ? 'Edit Vendor Credit' : 'Add New Vendor Credit'}
//                                 </h2>
//                                 {/* NEW: Show current organization in form */}
//                                 {currentOrganization?.name && (
//                                     <div className="flex items-center gap-2 mt-1">
//                                         <Building className="w-4 h-4 text-blue-600" />
//                                         <span className="text-sm text-blue-600 font-medium">{currentOrganization.name}</span>
//                                     </div>
//                                 )}
//                                 {/* NEW: Show synced status warning */}
//                                 {editingCredit?.sync_status === 'synced' && (
//                                     <div className="flex items-center gap-2 mt-2 px-3 py-2 bg-green-50 border border-green-200 rounded-lg">
//                                         <CheckCircle2 className="w-4 h-4 text-green-600" />
//                                         <span className="text-sm text-green-800 font-medium">
//                                             This credit has been synced to Zoho Books and cannot be edited
//                                         </span>
//                                     </div>
//                                 )}
//                                 {isLoadingVendor && (
//                                     <span className="text-sm text-blue-600">Loading vendor data...</span>
//                                 )}
//                                 {formData.gst_no && (
//                                     <div className="mt-1 text-sm text-gray-600">
//                                         Vendor State: {getStateFromGST(formData.gst_no)} |
//                                         Transaction: <span className={getTransactionType(formData.gst_no, 'TN').color}>
//                                             {getTransactionType(formData.gst_no, 'TN').type} ({getTransactionType(formData.gst_no, 'TN').taxType})
//                                         </span>
//                                     </div>
//                                 )}
//                             </div>
//                             <button
//                                 onClick={() => {
//                                     setShowForm(false);
//                                     setEditingCredit(null);
//                                     resetForm();
//                                 }}
//                                 className="text-gray-400 hover:text-gray-600"
//                             >
//                                 <X size={24} />
//                             </button>
//                         </div>

//                         <form onSubmit={handleSubmit} className="p-6 space-y-6">
//                             {/* Basic Information */}
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                 <div className="relative">
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Vendor Name *
//                                     </label>
//                                     <input
//                                         type="text"
//                                         required
//                                         value={formData.vendor_name}
//                                         onChange={(e) => {
//                                             setFormData({ ...formData, vendor_name: e.target.value });
//                                             if (e.target.value.length >= 2) {
//                                                 searchVendors(e.target.value);
//                                                 setShowVendorSuggestions(true);
//                                             } else {
//                                                 setShowVendorSuggestions(false);
//                                             }
//                                         }}
//                                         onFocus={() => {
//                                             if (vendorSuggestions.length > 0) {
//                                                 setShowVendorSuggestions(true);
//                                             }
//                                         }}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         placeholder="Type to search vendors..."
//                                     />

//                                     {/* Vendor Suggestions Dropdown */}
//                                     {showVendorSuggestions && vendorSuggestions.length > 0 && (
//                                         <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
//                                             {vendorSuggestions.map((vendor) => {
//                                                 const vendorState = getStateFromGST(vendor.gst_no);
//                                                 const transactionInfo = getTransactionType(vendor.gst_no, 'TN');

//                                                 return (
//                                                     <div
//                                                         key={vendor.vendor_id}
//                                                         onClick={() => handleVendorSelect(vendor)}
//                                                         className="px-3 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
//                                                     >
//                                                         <div className="font-medium text-gray-900">{vendor.vendor_name}</div>
//                                                         <div className="text-xs text-gray-500">
//                                                             ID: {vendor.vendor_id} | GST: {vendor.gst_no || 'N/A'}
//                                                             {vendor.gst_no && (
//                                                                 <span className={`ml-2 ${transactionInfo.color}`}>
//                                                                     {vendorState} ({transactionInfo.taxType})
//                                                                 </span>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 );
//                                             })}
//                                         </div>
//                                     )}
//                                 </div>
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Vendor ID *
//                                         {formData.vendor_id && (
//                                             <CheckCircle2 size={16} className="inline ml-1 text-green-500" />
//                                         )}
//                                     </label>
//                                     <input
//                                         type="text"
//                                         required
//                                         value={formData.vendor_id}
//                                         onChange={(e) => {
//                                             console.log('🔄 Vendor ID manually changed:', e.target.value);
//                                             setFormData({ ...formData, vendor_id: e.target.value });
//                                         }}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         placeholder="Auto-filled when vendor selected"
//                                     />
//                                     {/* DEBUG: Show current vendor_id value */}
//                                     {process.env.NODE_ENV === 'development' && (
//                                         <div className="text-xs text-gray-500 mt-1">
//                                             Debug: vendor_id = "{formData.vendor_id}"
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* NEW: Bill Selection Section */}
//                                 <div className="md:col-span-2">
//                                     <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
//                                         <div className="flex justify-between items-center mb-3">
//                                             <h3 className="text-sm font-medium text-gray-700">Bill Information</h3>
//                                             {formData.vendor_id && (
//                                                 <button
//                                                     type="button"
//                                                     onClick={() => setShowBillSelector(true)}
//                                                     className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1"
//                                                 >
//                                                     <FileText size={16} />
//                                                     Select from Bills
//                                                 </button>
//                                             )}
//                                         </div>

//                                         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                                                     Bill Number *
//                                                 </label>
//                                                 <input
//                                                     type="text"
//                                                     required
//                                                     value={formData.bill_number}
//                                                     onChange={(e) => setFormData({ ...formData, bill_number: e.target.value })}
//                                                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                 />
//                                             </div>

//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                                                     Bill Date *
//                                                 </label>
//                                                 <input
//                                                     type="date"
//                                                     required
//                                                     value={formData.bill_date}
//                                                     onChange={(e) => setFormData({ ...formData, bill_date: e.target.value })}
//                                                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                 />
//                                             </div>

//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                                                     Credit Amount *
//                                                 </label>
//                                                 <input
//                                                     type="number"
//                                                     step="0.01"
//                                                     required
//                                                     value={formData.debit_note_amount}
//                                                     onChange={(e) => setFormData({ ...formData, debit_note_amount: e.target.value })}
//                                                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Show selected bill info */}
//                                         {formData.selected_bill && (
//                                             <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
//                                                 <div className="flex items-center gap-2 text-sm text-green-800">
//                                                     <CheckCircle2 size={16} />
//                                                     <span className="font-medium">Linked to Bill:</span>
//                                                     <span>{formData.selected_bill.bill_number}</span>
//                                                     <span className="text-green-600">({formData.selected_bill.bill_id})</span>
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Reference Number
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={formData.reference_number}
//                                         onChange={(e) => setFormData({ ...formData, reference_number: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                     />
//                                 </div>
//                             </div>

//                             {/* Tax Information */}
//                             <div className="border-t pt-6">
//                                 <h3 className="text-lg font-medium text-gray-900 mb-4">Tax Information</h3>
//                                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             GST Number
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.gst_no}
//                                             onChange={(e) => setFormData({ ...formData, gst_no: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                             placeholder="Auto-filled from vendor"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             GST Treatment
//                                         </label>
//                                         <select
//                                             value={formData.gst_treatment}
//                                             onChange={(e) => setFormData({ ...formData, gst_treatment: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         >
//                                             <option value="business_gst">Business GST</option>
//                                             <option value="consumer">Consumer</option>
//                                             <option value="overseas">Overseas</option>
//                                         </select>
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Tax Treatment
//                                         </label>
//                                         <select
//                                             value={formData.tax_treatment}
//                                             onChange={(e) => setFormData({ ...formData, tax_treatment: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         >
//                                             <option value="vat_registered">VAT Registered</option>
//                                             <option value="vat_not_registered">VAT Not Registered</option>
//                                             <option value="overseas">Overseas</option>
//                                         </select>
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Source of Supply (Organization)
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.source_of_supply}
//                                             onChange={(e) => setFormData({ ...formData, source_of_supply: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Destination of Supply (Vendor)
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.destination_of_supply}
//                                             onChange={(e) => setFormData({ ...formData, destination_of_supply: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                             placeholder="Auto-filled from vendor GST"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Place of Supply
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.place_of_supply}
//                                             onChange={(e) => setFormData({ ...formData, place_of_supply: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Line Items */}
//                             <div className="border-t pt-6">
//                                 <div className="flex justify-between items-center mb-4">
//                                     <h3 className="text-lg font-medium text-gray-900">Line Items</h3>
//                                     <button
//                                         type="button"
//                                         onClick={addLineItem}
//                                         className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
//                                     >
//                                         <Plus size={16} />
//                                         Add Item
//                                     </button>
//                                 </div>

//                                 <div className="space-y-4">
//                                     {formData.line_items.map((item, index) => (
//                                         <div key={index} className="border border-gray-200 rounded-lg p-4">
//                                             <div className="flex justify-between items-center mb-3">
//                                                 <h4 className="font-medium text-gray-900">Item {index + 1}</h4>
//                                                 {formData.line_items.length > 1 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => removeLineItem(index)}
//                                                         className="text-red-600 hover:text-red-800"
//                                                     >
//                                                         <X size={16} />
//                                                     </button>
//                                                 )}
//                                             </div>

//                                             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
//                                                 <div className="lg:col-span-2">
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Item Name *
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         required
//                                                         value={item.name}
//                                                         onChange={(e) => updateLineItem(index, 'name', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div className="lg:col-span-2">
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Description
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.description}
//                                                         onChange={(e) => updateLineItem(index, 'description', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         HSN/SAC
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.hsn_or_sac}
//                                                         onChange={(e) => updateLineItem(index, 'hsn_or_sac', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Quantity *
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         required
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.quantity}
//                                                         onChange={(e) => updateLineItem(index, 'quantity', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Unit
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.unit}
//                                                         onChange={(e) => updateLineItem(index, 'unit', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Rate *
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         required
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.rate}
//                                                         onChange={(e) => updateLineItem(index, 'rate', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>
//                                             </div>

//                                             {/* Tax Information for Line Item */}
//                                             <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3 pt-3 border-t border-gray-100">
//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         CGST Rate (%)
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.cgst_rate}
//                                                         onChange={(e) => updateLineItem(index, 'cgst_rate', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         SGST Rate (%)
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.sgst_rate}
//                                                         onChange={(e) => updateLineItem(index, 'sgst_rate', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         IGST Rate (%)
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.igst_rate}
//                                                         onChange={(e) => updateLineItem(index, 'igst_rate', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 {/* <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Total Tax Amount
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.total_tax}
//                                                         onChange={(e) => updateLineItem(index, 'total_tax', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div> */}
//                                             </div>

//                                             {/* Line Item Total */}
//                                             <div className="mt-3 pt-3 border-t border-gray-100">
//                                                 <div className="flex justify-between items-center">
//                                                     <span className="text-sm font-medium text-gray-700">
//                                                         Subtotal: ₹ {((item.quantity || 0) * (item.rate || 0)).toFixed(2)}
//                                                     </span>
//                                                     <span className="text-sm font-medium text-gray-900">
//                                                         Total: ₹ {calculateLineItemTotal(item).toFixed(2)}
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>

//                                 {/* Grand Total */}
//                                 <div className="mt-4 p-4 bg-gray-50 rounded-lg">
//                                     <div className="flex justify-between items-center">
//                                         <span className="text-lg font-medium text-gray-900">Grand Total:</span>
//                                         <span className="text-lg font-bold text-blue-600">
//                                             ₹ {formData.line_items.reduce((total, item) => total + calculateLineItemTotal(item), 0).toFixed(2)}
//                                         </span>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Additional Information */}
//                             <div className="border-t pt-6">
//                                 <h3 className="text-lg font-medium text-gray-900 mb-4">Additional Information</h3>
//                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                     {/* <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Currency ID
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.currency_id}
//                                             onChange={(e) => setFormData({ ...formData, currency_id: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div> */}

//                                     {/* <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Exchange Rate
//                                         </label>
//                                         <input
//                                             type="number"
//                                             step="0.0001"
//                                             value={formData.exchange_rate}
//                                             onChange={(e) => setFormData({ ...formData, exchange_rate: parseFloat(e.target.value) || 1 })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div> */}

//                                     <div className="flex items-center space-x-6">
//                                         <label className="flex items-center">
//                                             <input
//                                                 type="checkbox"
//                                                 checked={formData.is_inclusive_tax}
//                                                 onChange={(e) => setFormData({ ...formData, is_inclusive_tax: e.target.checked })}
//                                                 className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//                                             />
//                                             <span className="ml-2 text-sm text-gray-700">Inclusive Tax</span>
//                                         </label>

//                                         {/* <label className="flex items-center">
//                                             <input
//                                                 type="checkbox"
//                                                 checked={formData.autoSync}
//                                                 onChange={(e) => setFormData({ ...formData, autoSync: e.target.checked })}
//                                                 className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//                                             />
//                                             <span className="ml-2 text-sm text-gray-700">Auto Sync to Zoho</span>
//                                         </label> */}
//                                     </div>
//                                 </div>

//                                 <div className="mt-4">
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Notes
//                                     </label>
//                                     <textarea
//                                         rows={3}
//                                         value={formData.notes}
//                                         onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         placeholder="Additional notes about this vendor credit..."
//                                     />
//                                 </div>
//                             </div>

//                             {/* Form Actions */}
//                             <div className="border-t pt-6 flex justify-end gap-3">
//                                 <button
//                                     type="button"
//                                     onClick={() => {
//                                         setShowForm(false);
//                                         setEditingCredit(null);
//                                         resetForm();
//                                     }}
//                                     className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
//                                 >
//                                     {editingCredit?.sync_status === 'synced' ? 'Close' : 'Cancel'}
//                                 </button>
//                                 {editingCredit?.sync_status !== 'synced' && (
//                                     <button
//                                         type="submit"
//                                         disabled={isLoading || isLoadingVendor}
//                                         className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                                     >
//                                         <Save size={16} />
//                                         {isLoading ? 'Saving...' : editingCredit ? 'Update Credit' : 'Create Credit'}
//                                     </button>
//                                 )}
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}

//             {/* NEW: Bill Selector Modal */}
//             {showBillSelector && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-lg max-w-4xl w-full max-h-[80vh] overflow-hidden">
//                         <div className="px-6 py-4 border-b border-gray-200">
//                             <div className="flex justify-between items-center">
//                                 <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
//                                     <FileText className="w-5 h-5 text-blue-600" />
//                                     Select Bill for {formData.vendor_name}
//                                 </h3>
//                                 <button
//                                     onClick={() => setShowBillSelector(false)}
//                                     className="text-gray-400 hover:text-gray-600"
//                                 >
//                                     <X size={24} />
//                                 </button>
//                             </div>
//                         </div>

//                         <div className="p-6 overflow-y-auto max-h-[60vh]">
//                             {isLoadingBills ? (
//                                 <div className="flex items-center justify-center py-8">
//                                     <RefreshCcw className="w-8 h-8 text-blue-600 animate-spin" />
//                                     <span className="ml-2 text-gray-600">Loading bills...</span>
//                                 </div>
//                             ) : vendorBills.length === 0 ? (
//                                 <div className="text-center py-8">
//                                     <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
//                                     <p className="text-gray-500 mb-2">No bills found for this vendor</p>
//                                     <p className="text-sm text-gray-400">You can still create a credit by entering bill details manually</p>
//                                 </div>
//                             ) : (
//                                 <div className="space-y-3">
//                                     <div className="text-sm text-gray-600 mb-4">
//                                         Select a bill to link with this vendor credit:
//                                     </div>
//                                     {vendorBills.map((bill) => (
//                                         <div
//                                             key={bill.bill_id}
//                                             className={`border rounded-lg p-4 cursor-pointer transition-all hover:shadow-md ${formData.zoho_bill_id === bill.bill_id
//                                                 ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-200'
//                                                 : 'border-gray-200 hover:border-blue-300 hover:bg-gray-50'
//                                                 }`}
//                                             onClick={() => handleBillSelect(bill)}
//                                         >
//                                             <div className="flex items-center justify-between">
//                                                 <div className="flex-1">
//                                                     <div className="flex items-center gap-3">
//                                                         <FileText className="w-5 h-5 text-gray-400" />
//                                                         <div>
//                                                             <h4 className="font-medium text-gray-900">{bill.bill_number}</h4>
//                                                             <p className="text-sm text-gray-500">ID: {bill.bill_id}</p>
//                                                         </div>
//                                                     </div>
//                                                     <div className="mt-2 flex gap-6 text-sm text-gray-600">
//                                                         <div className="flex items-center gap-1">
//                                                             <Calendar className="w-4 h-4" />
//                                                             <span>{new Date(bill.date).toLocaleDateString()}</span>
//                                                         </div>
//                                                         <span>💰 Total: ₹ {parseFloat(bill.total || 0).toFixed(2)}</span>
//                                                         <span>📊 Balance: ₹ {parseFloat(bill.balance || 0).toFixed(2)}</span>
//                                                         <span className={`px-2 py-1 rounded text-xs ${bill.status === 'paid' ? 'bg-green-100 text-green-800' :
//                                                             bill.status === 'overdue' ? 'bg-red-100 text-red-800' :
//                                                                 'bg-yellow-100 text-yellow-800'
//                                                             }`}>
//                                                             {bill.status}
//                                                         </span>
//                                                     </div>
//                                                 </div>
//                                                 <div className="flex items-center gap-2">
//                                                     {formData.zoho_bill_id === bill.bill_id ? (
//                                                         <div className="flex items-center gap-2">
//                                                             <CheckCircle2 className="w-5 h-5 text-green-600" />
//                                                             <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full font-medium">
//                                                                 Selected
//                                                             </span>
//                                                         </div>
//                                                     ) : (
//                                                         <div className="text-blue-600 hover:text-blue-800">
//                                                             <span className="text-xs bg-blue-100 hover:bg-blue-200 px-3 py-1 rounded-full font-medium transition-colors">
//                                                                 Select
//                                                             </span>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>

//                         <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
//                             <div className="flex justify-between items-center">
//                                 <div className="text-sm text-gray-600">
//                                     {vendorBills.length > 0 && (
//                                         <span>{vendorBills.length} bill{vendorBills.length !== 1 ? 's' : ''} available</span>
//                                     )}
//                                 </div>
//                                 <div className="flex gap-3">
//                                     <button
//                                         onClick={() => formData.vendor_id && fetchVendorBills(formData.vendor_id)}
//                                         disabled={isLoadingBills || !formData.vendor_id}
//                                         className="flex items-center gap-2 px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
//                                     >
//                                         <RefreshCcw className={`w-4 h-4 ${isLoadingBills ? 'animate-spin' : ''}`} />
//                                         Refresh
//                                     </button>
//                                     <button
//                                         onClick={() => setShowBillSelector(false)}
//                                         className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700"
//                                     >
//                                         Close
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default VendorCreditManagement;




// import { useState, useEffect } from 'react';
// import { Plus, Edit2, Trash2, RefreshCcw, Save, X, Search, Filter, AlertCircle, CheckCircle2, MapPin, Building, FileText, Calendar } from 'lucide-react';

// const VendorCreditManagement = () => {
//     const [debitNotes, setDebitNotes] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isLoadingVendor, setIsLoadingVendor] = useState(false);
//     const [isLoadingBills, setIsLoadingBills] = useState(false);
//     const [showForm, setShowForm] = useState(false);
//     const [editingDebitNote, setEditingDebitNote] = useState(null);
//     const [pagination, setPagination] = useState({
//         page: 1,
//         limit: 10,
//         total: 0,
//         totalPages: 0
//     });
//     const [searchTerm, setSearchTerm] = useState('');
//     const [filter, setFilter] = useState('all');
//     const [vendorSuggestions, setVendorSuggestions] = useState([]);
//     const [showVendorSuggestions, setShowVendorSuggestions] = useState(false);
//     const [vendorBills, setVendorBills] = useState([]);
//     const [showBillSelector, setShowBillSelector] = useState(false);

//     const [formData, setFormData] = useState({
//         vendor_name: '',
//         bill_number: '',
//         bill_date: '',
//         balance: '',
//         debit_note_amount: '',
//         vendor_id: '',
//         currency_id: '3000000000083',
//         vat_treatment: '',
//         vendor_debit_number: '',
//         gst_treatment: 'business_gst',
//         tax_treatment: 'vat_registered',
//         gst_no: '',
//         source_of_supply: 'TN',
//         destination_of_supply: 'TN',
//         place_of_supply: 'DU',
//         pricebook_id: '',
//         reference_number: '',
//         is_update_customer: false,
//         exchange_rate: 1,
//         is_inclusive_tax: false,
//         location_id: '',
//         line_items: [{
//             item_id: '',
//             name: '',
//             description: '',
//             quantity: 1,
//             unit: 'Nos',
//             rate: 0,
//             tax_id: '',
//             hsn_or_sac: '',
//             cgst_rate: 0,
//             sgst_rate: 0,
//             igst_rate: 0,
//             total_tax: 0
//         }],
//         notes: '',
//         custom_fields: [],
//         company_id: '1',
//         autoSync: false,
//         zoho_bill_id: '',
//         selected_bill: null,
//         reason: 'price_adjustment' // New field specific to debit notes
//     });

//     // Organization state
//     const [currentOrganization, setCurrentOrganization] = useState({
//         organization_id: '',
//         name: ''
//     });

//     const API_BASE_URL = 'https://api.zapbooksai.subraps.com/api';

//     // Get authentication headers
//     const getAuthHeaders = () => {
//         const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
//         return {
//             'Content-Type': 'application/json',
//             ...(token && { 'Authorization': `Bearer ${token}` })
//         };
//     };

//     // Fetch current organization
//     const fetchCurrentOrganization = async () => {
//         try {
//             console.log('🔍 Fetching current organization...');
//             const response = await fetch(`${API_BASE_URL}/token/status`, {
//                 headers: getAuthHeaders()
//             });
//             const result = await response.json();

//             if (result.success && result.data.current_organization) {
//                 const org = result.data.current_organization;
//                 console.log('✅ Current organization fetched:', org);
//                 setCurrentOrganization(org);
//                 return org.organization_id;
//             } else {
//                 console.error('❌ No current organization found');
//                 throw new Error('No current organization found');
//             }
//         } catch (error) {
//             console.error('❌ Error fetching current organization:', error);
//         }
//     };

//     // Helper function to extract state code from GST number
//     const getStateFromGST = (gstNumber) => {
//         if (!gstNumber || gstNumber.length < 2) return null;

//         const stateCode = gstNumber.substring(0, 2);
//         const gstStateMapping = {
//             '01': 'Jammu & Kashmir', '02': 'Himachal Pradesh', '03': 'Punjab', '04': 'Chandigarh',
//             '05': 'Uttarakhand', '06': 'Haryana', '07': 'Delhi', '08': 'Rajasthan',
//             '09': 'Uttar Pradesh', '10': 'Bihar', '11': 'Sikkim', '12': 'Arunachal Pradesh',
//             '13': 'Nagaland', '14': 'Manipur', '15': 'Mizoram', '16': 'Tripura',
//             '17': 'Meghalaya', '18': 'Assam', '19': 'West Bengal', '20': 'Jharkhand',
//             '21': 'Odisha', '22': 'Chhattisgarh', '23': 'Madhya Pradesh', '24': 'Gujarat',
//             '25': 'Daman & Diu', '26': 'Dadra & Nagar Haveli', '27': 'Maharashtra',
//             '28': 'Andhra Pradesh', '29': 'Karnataka', '30': 'Goa', '31': 'Lakshadweep',
//             '32': 'Kerala', '33': 'Tamil Nadu', '34': 'Puducherry', '35': 'Andaman & Nicobar',
//             '36': 'Telangana', '37': 'Andhra Pradesh', '38': 'Ladakh'
//         };

//         return gstStateMapping[stateCode] || `State Code: ${stateCode}`;
//     };

//     // Determine transaction type based on GST states
//     const getTransactionType = (vendorGST, orgState = 'TN') => {
//         if (!vendorGST) return { type: 'Unknown', taxType: 'GST' };

//         const vendorStateCode = vendorGST.substring(0, 2);
//         const orgStateCode = orgState === 'TN' ? '33' : ''; // Default to TN

//         const isIntraState = vendorStateCode === orgStateCode;

//         return {
//             type: isIntraState ? 'Intra-State' : 'Inter-State',
//             taxType: isIntraState ? 'CGST+SGST' : 'IGST',
//             color: isIntraState ? 'text-green-600' : 'text-blue-600'
//         };
//     };

//     // Search vendors in Zoho Books
//     const searchVendors = async (searchTerm) => {
//         if (!searchTerm || searchTerm.length < 2) {
//             setVendorSuggestions([]);
//             return;
//         }

//         try {
//             setIsLoadingVendor(true);
//             console.log('🔍 Searching vendors for term:', searchTerm);
//             console.log('🏢 Using organization ID:', currentOrganization?.organization_id);

//             const searchParams = new URLSearchParams({
//                 query: searchTerm
//             });

//             if (currentOrganization?.organization_id) {
//                 searchParams.append('organization_id', currentOrganization.organization_id);
//             }

//             const response = await fetch(`${API_BASE_URL}/zoho/vendors/search?${searchParams}`, {
//                 headers: getAuthHeaders()
//             });

//             console.log('📡 Vendor search response status:', response.status);

//             const result = await response.json();
//             console.log('📊 Vendor search result:', result);

//             if (result.success && result.data.vendors) {
//                 console.log('✅ Found vendors:', result.data.vendors.length);
//                 console.log('📋 First vendor data:', result.data.vendors[0]);
//                 console.log('🏢 Search performed in org:', result.data.debug?.organizationId);

//                 setVendorSuggestions(result.data.vendors.slice(0, 10));
//             } else {
//                 console.warn('⚠️ No vendors found or API error:', result.message);
//                 console.log('🏢 Organization used:', result.data?.debug?.organizationId);
//                 setVendorSuggestions([]);
//             }
//         } catch (error) {
//             console.error('❌ Error searching vendors:', error);
//             setVendorSuggestions([]);
//         } finally {
//             setIsLoadingVendor(false);
//         }
//     };

//     // Get vendor details from Zoho Books
//     const getVendorDetails = async (vendorId) => {
//         try {
//             setIsLoadingVendor(true);
//             console.log('🔍 Fetching vendor details for ID:', vendorId);
//             console.log('🏢 Using organization ID:', currentOrganization?.organization_id);

//             const detailsParams = new URLSearchParams();
//             if (currentOrganization?.organization_id) {
//                 detailsParams.append('organization_id', currentOrganization.organization_id);
//             }

//             const response = await fetch(`${API_BASE_URL}/zoho/vendors/${vendorId}?${detailsParams}`, {
//                 headers: getAuthHeaders()
//             });

//             console.log('📡 Vendor details response status:', response.status);

//             const result = await response.json();
//             console.log('📊 Vendor details result:', result);

//             if (result.success && result.data.vendor) {
//                 console.log('✅ Vendor details fetched successfully:', result.data.vendor);
//                 console.log('🏢 Details fetched from org:', result.data.debug?.organizationId);
//                 return result.data.vendor;
//             } else {
//                 console.warn('⚠️ Failed to fetch vendor details:', result.message);
//                 console.log('🏢 Organization used:', result.data?.debug?.organizationId);
//             }
//             return null;
//         } catch (error) {
//             console.error('❌ Error fetching vendor details:', error);
//             return null;
//         } finally {
//             setIsLoadingVendor(false);
//         }
//     };

//     // Fetch vendor bills
//     const fetchVendorBills = async (vendorId) => {
//         if (!vendorId) return;

//         try {
//             setIsLoadingBills(true);
//             console.log('🔍 Fetching bills for vendor ID:', vendorId);
//             console.log('🏢 Using organization ID:', currentOrganization?.organization_id);

//             const billsParams = new URLSearchParams();
//             if (currentOrganization?.organization_id) {
//                 billsParams.append('organization_id', currentOrganization.organization_id);
//             }

//             const response = await fetch(`${API_BASE_URL}/zoho/vendors/${vendorId}/bills?${billsParams}`, {
//                 headers: getAuthHeaders()
//             });

//             console.log('📡 Vendor bills response status:', response.status);

//             const result = await response.json();
//             console.log('📊 Vendor bills result:', result);

//             if (result.success && result.data.bills) {
//                 console.log('✅ Found bills:', result.data.bills.length);
//                 console.log('📋 Bills data:', result.data.bills);
//                 setVendorBills(result.data.bills);
//                 return result.data.bills;
//             } else {
//                 console.warn('⚠️ No bills found or API error:', result.message);
//                 setVendorBills([]);
//                 return [];
//             }
//         } catch (error) {
//             console.error('❌ Error fetching vendor bills:', error);
//             setVendorBills([]);
//             return [];
//         } finally {
//             setIsLoadingBills(false);
//         }
//     };

//     // Handle vendor selection
//     const handleVendorSelect = async (vendor) => {
//         console.log('🔄 Vendor selected:', vendor);

//         setFormData(prev => ({
//             ...prev,
//             vendor_name: vendor.vendor_name,
//             vendor_id: vendor.vendor_id
//         }));

//         setShowVendorSuggestions(false);
//         setVendorSuggestions([]);

//         try {
//             setIsLoadingVendor(true);
//             const vendorDetails = await getVendorDetails(vendor.vendor_id);

//             if (vendorDetails) {
//                 console.log('✅ Vendor details fetched:', vendorDetails);

//                 let destinationState = null;
//                 let placeOfSupply = null;

//                 if (vendorDetails.gst_no) {
//                     const gstStateCode = vendorDetails.gst_no.substring(0, 2);
//                     const stateCodeMapping = {
//                         '33': 'TN', '24': 'GJ', '27': 'MH', '29': 'KA', '07': 'DL',
//                         '32': 'KL', '28': 'AP', '36': 'TG', '19': 'WB', '09': 'UP'
//                     };
//                     destinationState = stateCodeMapping[gstStateCode] || gstStateCode;
//                     placeOfSupply = destinationState;
//                 }

//                 setFormData(prev => ({
//                     ...prev,
//                     vendor_name: vendorDetails.vendor_name,
//                     vendor_id: vendorDetails.vendor_id,
//                     gst_no: vendorDetails.gst_no || '',
//                     gst_treatment: vendorDetails.gst_treatment || 'business_gst',
//                     tax_treatment: vendorDetails.tax_treatment || 'vat_registered',
//                     place_of_supply: placeOfSupply || vendorDetails.place_of_supply || prev.place_of_supply,
//                     source_of_supply: 'TN',
//                     destination_of_supply: destinationState || vendorDetails.billing_address?.state_code || prev.destination_of_supply,
//                     currency_id: vendorDetails.currency_id || prev.currency_id
//                 }));

//                 console.log('✅ Form updated with vendor details');
//             } else {
//                 console.warn('⚠️ No vendor details returned from API');
//             }

//             await fetchVendorBills(vendor.vendor_id);

//         } catch (error) {
//             console.error('❌ Error in handleVendorSelect:', error);
//             setFormData(prev => ({
//                 ...prev,
//                 vendor_name: vendor.vendor_name,
//                 vendor_id: vendor.vendor_id
//             }));
//         } finally {
//             setIsLoadingVendor(false);
//         }
//     };

//     // Handle bill selection
//     const handleBillSelect = (bill) => {
//         setFormData(prev => ({
//             ...prev,
//             bill_number: bill.bill_number,
//             bill_date: bill.date,
//             balance: bill.balance || bill.total,
//             zoho_bill_id: bill.bill_id,
//             selected_bill: bill
//         }));
//         setShowBillSelector(false);
//     };

//     // Enhanced line item handling for existing data
//     const parseLineItemsFromDatabase = (lineItemsData) => {
//         if (!lineItemsData) return getDefaultLineItem();

//         try {
//             let parsedItems = [];

//             console.log('🔍 Raw line items data:', lineItemsData);

//             if (typeof lineItemsData === 'string') {
//                 try {
//                     parsedItems = JSON.parse(lineItemsData);
//                 } catch (parseError) {
//                     console.error('❌ JSON parse error:', parseError);
//                     return getDefaultLineItem();
//                 }
//             } else if (Array.isArray(lineItemsData)) {
//                 parsedItems = lineItemsData;
//             } else if (typeof lineItemsData === 'object') {
//                 parsedItems = [lineItemsData];
//             }

//             if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
//                 return getDefaultLineItem();
//             }

//             const formattedItems = parsedItems.map((item) => ({
//                 item_id: item.item_id || '',
//                 name: item.name || '',
//                 description: item.description || item.name || '',
//                 quantity: parseFloat(item.quantity) || 1,
//                 unit: item.unit || 'Nos',
//                 rate: parseFloat(item.rate) || 0,
//                 tax_id: item.tax_id || '',
//                 hsn_or_sac: item.hsn_or_sac || '',
//                 cgst_rate: parseFloat(item.cgst_rate) || 0,
//                 sgst_rate: parseFloat(item.sgst_rate) || 0,
//                 igst_rate: parseFloat(item.igst_rate) || 0,
//                 total_tax: parseFloat(item.total_tax) || 0
//             }));

//             return formattedItems;

//         } catch (error) {
//             console.error('❌ Error parsing line items:', error);
//             return getDefaultLineItem();
//         }
//     };

//     const getDefaultLineItem = () => [{
//         item_id: '',
//         name: '',
//         description: '',
//         quantity: 1,
//         unit: 'Nos',
//         rate: 0,
//         tax_id: '',
//         hsn_or_sac: '',
//         cgst_rate: 0,
//         sgst_rate: 0,
//         igst_rate: 0,
//         total_tax: 0
//     }];

//     // Calculate line item total including tax
//     const calculateLineItemTotal = (item) => {
//         const subtotal = (parseFloat(item.quantity) || 0) * (parseFloat(item.rate) || 0);
//         const totalTax = parseFloat(item.total_tax) || 0;
//         return subtotal + totalTax;
//     };

//     // Initialize component
//     useEffect(() => {
//         const initializeComponent = async () => {
//             try {
//                 await fetchCurrentOrganization();
//             } catch (error) {
//                 console.error('Failed to initialize component:', error);
//             }
//         };

//         initializeComponent();
//     }, []);

//     useEffect(() => {
//         if (currentOrganization?.organization_id) {
//             fetchDebitNotes();
//         }
//     }, [pagination.page, searchTerm, filter, currentOrganization?.organization_id]);

//     const fetchDebitNotes = async () => {
//         if (!currentOrganization?.organization_id) {
//             console.log('❌ No organization ID available, skipping load');
//             return;
//         }
//         setIsLoading(true);
//         try {
//             const params = new URLSearchParams({
//                 page: pagination.page,
//                 limit: pagination.limit,
//                 company_id: currentOrganization?.organization_id
//             });

//             const response = await fetch(`${API_BASE_URL}/vendor-debit-notes?${params}`, {
//                 headers: getAuthHeaders()
//             });
//             const result = await response.json();

//             if (result.success) {
//                 setDebitNotes(result.data.debitNotes);
//                 setPagination(prev => ({
//                     ...prev,
//                     total: result.data.total,
//                     totalPages: result.data.totalPages
//                 }));
//             }
//         } catch (error) {
//             console.error('Error fetching debit notes:', error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleSubmit = async () => {
//         setIsLoading(true);

//         try {
//             const { selected_bill, ...formDataToSend } = formData;

//             const formattedData = {
//                 ...formDataToSend,
//                 bill_date: formDataToSend.bill_date || null,
//                 company_id: currentOrganization?.organization_id
//             };

//             Object.keys(formattedData).forEach(key => {
//                 if (formattedData[key] === '' || formattedData[key] === undefined) {
//                     formattedData[key] = null;
//                 }
//             });

//             console.log('📤 Sending formatted data:', formattedData);

//             const url = editingDebitNote ? `${API_BASE_URL}/vendor-debit-notes/${editingDebitNote.id}` : `${API_BASE_URL}/vendor-debit-notes`;
//             const method = editingDebitNote ? 'PUT' : 'POST';

//             const response = await fetch(url, {
//                 method,
//                 headers: getAuthHeaders(),
//                 body: JSON.stringify(formattedData),
//             });

//             const result = await response.json();

//             if (result.success) {
//                 setShowForm(false);
//                 setEditingDebitNote(null);
//                 resetForm();
//                 fetchDebitNotes();
//                 alert(editingDebitNote ? 'Debit note updated successfully!' : 'Debit note created successfully!');
//             } else {
//                 alert('Error: ' + result.message);
//             }
//         } catch (error) {
//             console.error('Error saving debit note:', error);
//             alert('Error saving debit note');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleEdit = async (debitNote) => {
//         setEditingDebitNote(debitNote);
//         setIsLoadingVendor(true);

//         try {
//             let freshDebitNote = debitNote;
//             try {
//                 const debitNoteResponse = await fetch(`${API_BASE_URL}/vendor-debit-notes/${debitNote.id}`, {
//                     headers: getAuthHeaders()
//                 });
//                 if (debitNoteResponse.ok) {
//                     const debitNoteResult = await debitNoteResponse.json();
//                     if (debitNoteResult.success) {
//                         freshDebitNote = debitNoteResult.data;
//                     }
//                 }
//             } catch (debitNoteError) {
//                 console.warn('Could not fetch fresh debit note data:', debitNoteError);
//             }

//             const dbDate = freshDebitNote.bill_date ? new Date(freshDebitNote.bill_date) : null;
//             const localDate = dbDate ?
//                 `${dbDate.getFullYear()}-${String(dbDate.getMonth() + 1).padStart(2, '0')}-${String(dbDate.getDate()).padStart(2, '0')}` :
//                 '';

//             const parsedLineItems = parseLineItemsFromDatabase(freshDebitNote.line_items);

//             setFormData({
//                 ...freshDebitNote,
//                 bill_date: localDate,
//                 line_items: parsedLineItems,
//                 autoSync: false,
//                 company_id: currentOrganization?.organization_id,
//                 selected_bill: freshDebitNote.zoho_bill_id ? {
//                     bill_id: freshDebitNote.zoho_bill_id,
//                     bill_number: freshDebitNote.bill_number
//                 } : null
//             });

//             if (freshDebitNote.vendor_id) {
//                 console.log('🔄 Refreshing vendor details for ID:', freshDebitNote.vendor_id);

//                 await fetchVendorBills(freshDebitNote.vendor_id);

//                 const vendorDetails = await getVendorDetails(freshDebitNote.vendor_id);

//                 if (vendorDetails) {
//                     let destinationState = null;
//                     let placeOfSupply = null;

//                     if (vendorDetails.gst_no) {
//                         const gstStateCode = vendorDetails.gst_no.substring(0, 2);
//                         const stateCodeMapping = {
//                             '33': 'TN', '24': 'GJ', '27': 'MH', '29': 'KA', '07': 'DL',
//                             '32': 'KL', '28': 'AP', '36': 'TG', '19': 'WB', '09': 'UP'
//                         };
//                         destinationState = stateCodeMapping[gstStateCode] || gstStateCode;
//                         placeOfSupply = destinationState;
//                     }

//                     setFormData(prev => ({
//                         ...prev,
//                         vendor_name: vendorDetails.vendor_name,
//                         gst_no: vendorDetails.gst_no || prev.gst_no,
//                         gst_treatment: vendorDetails.gst_treatment || prev.gst_treatment,
//                         tax_treatment: vendorDetails.tax_treatment || prev.tax_treatment,
//                         place_of_supply: placeOfSupply || vendorDetails.place_of_supply || prev.place_of_supply,
//                         source_of_supply: 'TN',
//                         destination_of_supply: destinationState || vendorDetails.billing_address?.state_code || prev.destination_of_supply,
//                         currency_id: vendorDetails.currency_id || prev.currency_id
//                     }));
//                 }
//             }

//         } catch (error) {
//             console.error('Error in handleEdit:', error);
//         } finally {
//             setIsLoadingVendor(false);
//             setShowForm(true);
//         }
//     };

//     const handleDelete = async (id) => {
//         if (window.confirm('Are you sure you want to delete this debit note?')) {
//             try {
//                 const response = await fetch(`${API_BASE_URL}/vendor-debit-notes/${id}`, {
//                     method: 'DELETE',
//                     headers: getAuthHeaders()
//                 });

//                 const result = await response.json();

//                 if (result.success) {
//                     fetchDebitNotes();
//                     alert('Debit note deleted successfully!');
//                 } else {
//                     alert('Error: ' + result.message);
//                 }
//             } catch (error) {
//                 console.error('Error deleting debit note:', error);
//                 alert('Error deleting debit note');
//             }
//         }
//     };

//     const handleSync = async (id) => {
//         try {
//             const syncPayload = {
//                 organization_id: currentOrganization?.organization_id
//             };

//             console.log('🔄 Syncing with organization ID:', currentOrganization?.organization_id);

//             const response = await fetch(`${API_BASE_URL}/vendor-debit-notes/${id}/sync`, {
//                 method: 'POST',
//                 headers: getAuthHeaders(),
//                 body: JSON.stringify(syncPayload)
//             });

//             const result = await response.json();

//             if (result.success) {
//                 fetchDebitNotes();
//                 alert('Debit note synced to Zoho Books successfully!');
//                 console.log('✅ Sync result:', result.data);
//             } else {
//                 alert('Sync error: ' + result.message);
//                 console.error('❌ Sync error:', result.message);
//             }
//         } catch (error) {
//             console.error('Error syncing debit note:', error);
//             alert('Error syncing debit note');
//         }
//     };

//     const resetForm = () => {
//         setFormData({
//             vendor_name: '',
//             bill_number: '',
//             bill_date: '',
//             balance: '',
//             debit_note_amount: '',
//             vendor_id: '',
//             currency_id: '3000000000083',
//             vat_treatment: '',
//             vendor_debit_number: '',
//             gst_treatment: 'business_gst',
//             tax_treatment: 'vat_registered',
//             gst_no: '',
//             source_of_supply: 'TN',
//             destination_of_supply: 'TN',
//             place_of_supply: 'DU',
//             pricebook_id: '',
//             reference_number: '',
//             is_update_customer: false,
//             exchange_rate: 1,
//             is_inclusive_tax: false,
//             location_id: '',
//             line_items: getDefaultLineItem(),
//             notes: '',
//             custom_fields: [],
//             company_id: currentOrganization?.organization_id || '1',
//             autoSync: false,
//             zoho_bill_id: '',
//             selected_bill: null,
//             reason: 'price_adjustment'
//         });
//         setVendorSuggestions([]);
//         setShowVendorSuggestions(false);
//         setVendorBills([]);
//         setShowBillSelector(false);
//     };

//     const addLineItem = () => {
//         setFormData(prev => ({
//             ...prev,
//             line_items: [...prev.line_items, {
//                 item_id: '',
//                 name: '',
//                 description: '',
//                 quantity: 1,
//                 unit: 'Nos',
//                 rate: 0,
//                 tax_id: '',
//                 hsn_or_sac: '',
//                 cgst_rate: 0,
//                 sgst_rate: 0,
//                 igst_rate: 0,
//                 total_tax: 0
//             }]
//         }));
//     };

//     const removeLineItem = (index) => {
//         setFormData(prev => ({
//             ...prev,
//             line_items: prev.line_items.filter((_, i) => i !== index)
//         }));
//     };

//     const updateLineItem = (index, field, value) => {
//         setFormData(prev => ({
//             ...prev,
//             line_items: prev.line_items.map((item, i) =>
//                 i === index ? { ...item, [field]: value } : item
//             )
//         }));
//     };

//     const getSyncStatusBadge = (status) => {
//         const badges = {
//             'pending': 'bg-yellow-100 text-yellow-800',
//             'synced': 'bg-green-100 text-green-800',
//             'error': 'bg-red-100 text-red-800'
//         };
//         return badges[status] || 'bg-gray-100 text-gray-800';
//     };

//     const getReasonBadge = (reason) => {
//         const badges = {
//             'price_adjustment': 'bg-blue-100 text-blue-800',
//             'additional_charges': 'bg-purple-100 text-purple-800',
//             'penalty': 'bg-red-100 text-red-800',
//             'quantity_adjustment': 'bg-orange-100 text-orange-800',
//             'other': 'bg-gray-100 text-gray-800'
//         };
//         const labels = {
//             'price_adjustment': 'Price Adjustment',
//             'additional_charges': 'Additional Charges',
//             'penalty': 'Penalty',
//             'quantity_adjustment': 'Quantity Adjustment',
//             'other': 'Other'
//         };
//         return { badge: badges[reason] || 'bg-gray-100 text-gray-800', label: labels[reason] || 'Other' };
//     };

//     const filteredDebitNotes = debitNotes.filter(debitNote => {
//         const matchesSearch = debitNote.vendor_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             debitNote.bill_number.toLowerCase().includes(searchTerm.toLowerCase());

//         if (filter === 'all') return matchesSearch;
//         return matchesSearch && debitNote.sync_status === filter;
//     });

//     return (
//         <div className="max-w-7xl mx-auto p-6">
//             <div className="flex justify-between items-center mb-6">
//                 <div>
//                     <h1 className="text-3xl font-bold text-gray-900">Vendor Debit Note Management</h1>
//                     {currentOrganization?.name && (
//                         <div className="flex items-center gap-2 mt-2">
//                             <Building className="w-4 h-4 text-blue-600" />
//                             <span className="text-sm text-gray-600">
//                                 Organization: <span className="font-medium text-blue-600">{currentOrganization.name}</span>
//                             </span>
//                         </div>
//                     )}
//                 </div>
//                 <button
//                     onClick={() => {
//                         resetForm();
//                         setShowForm(true);
//                     }}
//                     className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
//                 >
//                     <Plus size={20} />
//                     Add Debit Note
//                 </button>
//             </div>

//             {/* Search and Filter */}
//             <div className="mb-6 flex gap-4">
//                 <div className="flex-1 relative">
//                     <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                     <input
//                         type="text"
//                         placeholder="Search by vendor name or bill number..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     />
//                 </div>
//                 <div className="flex items-center gap-2">
//                     <Filter size={20} className="text-gray-400" />
//                     <select
//                         value={filter}
//                         onChange={(e) => setFilter(e.target.value)}
//                         className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     >
//                         <option value="all">All Status</option>
//                         <option value="pending">Pending</option>
//                         <option value="synced">Synced</option>
//                         <option value="error">Error</option>
//                     </select>
//                 </div>
//             </div>

//             {/* Debit Notes Table */}
//             <div className="bg-white rounded-lg shadow-md overflow-hidden">
//                 <div className="overflow-x-auto">
//                     <table className="w-full">
//                         <thead className="bg-gray-50">
//                             <tr>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vendor</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bill Info</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Reason</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tax Info</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className="bg-white divide-y divide-gray-200">
//                             {isLoading ? (
//                                 <tr>
//                                     <td colSpan="8" className="px-6 py-4 text-center text-gray-500">Loading...</td>
//                                 </tr>
//                             ) : filteredDebitNotes.length === 0 ? (
//                                 <tr>
//                                     <td colSpan="8" className="px-6 py-4 text-center text-gray-500">No debit notes found</td>
//                                 </tr>
//                             ) : (
//                                 filteredDebitNotes.map((debitNote) => {
//                                     const transactionInfo = getTransactionType(debitNote.gst_no, 'TN');
//                                     const vendorState = getStateFromGST(debitNote.gst_no);
//                                     const reasonInfo = getReasonBadge(debitNote.reason);

//                                     return (
//                                         <tr key={debitNote.id} className="hover:bg-gray-50">
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <div className="flex items-center">
//                                                     <div>
//                                                         <div className="text-sm font-medium text-gray-900">{debitNote.vendor_name}</div>
//                                                         <div className="flex items-center gap-1 text-xs text-gray-500">
//                                                             {debitNote.vendor_id ? (
//                                                                 <>
//                                                                     <CheckCircle2 size={12} className="text-green-500" />
//                                                                     <span>ID: {debitNote.vendor_id}</span>
//                                                                 </>
//                                                             ) : (
//                                                                 <>
//                                                                     <AlertCircle size={12} className="text-yellow-500" />
//                                                                     <span className="text-yellow-600">Missing ID</span>
//                                                                 </>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <div className="text-sm text-gray-900">{debitNote.bill_number}</div>
//                                                 {debitNote.zoho_bill_id && (
//                                                     <div className="flex items-center gap-1 text-xs text-green-600">
//                                                         <FileText size={12} />
//                                                         <span>Linked to Zoho</span>
//                                                     </div>
//                                                 )}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                                                 {debitNote.bill_date ? new Date(debitNote.bill_date).toLocaleDateString() : '-'}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                                                 ₹ {parseFloat(debitNote.debit_note_amount || 0).toFixed(2)}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${reasonInfo.badge}`}>
//                                                     {reasonInfo.label}
//                                                 </span>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <div className="text-sm">
//                                                     {debitNote.gst_no ? (
//                                                         <div>
//                                                             <div className="flex items-center gap-1">
//                                                                 <Building size={12} className="text-gray-400" />
//                                                                 <span className="text-xs font-mono">{debitNote.gst_no}</span>
//                                                             </div>
//                                                             <div className="flex items-center gap-1 mt-1">
//                                                                 <MapPin size={12} className="text-gray-400" />
//                                                                 <span className="text-xs text-gray-600">{vendorState}</span>
//                                                             </div>
//                                                             <div className={`text-xs font-medium mt-1 ${transactionInfo.color}`}>
//                                                                 {transactionInfo.type} ({transactionInfo.taxType})
//                                                             </div>
//                                                         </div>
//                                                     ) : (
//                                                         <div className="flex items-center gap-1">
//                                                             <AlertCircle size={12} className="text-yellow-500" />
//                                                             <span className="text-xs text-yellow-600">No GST Info</span>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getSyncStatusBadge(debitNote.sync_status)}`}>
//                                                     {debitNote.sync_status}
//                                                 </span>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                                                 <div className="flex gap-2">
//                                                     <button
//                                                         onClick={() => handleEdit(debitNote)}
//                                                         disabled={debitNote.sync_status === 'synced'}
//                                                         className={`${debitNote.sync_status === 'synced'
//                                                             ? 'text-gray-400 cursor-not-allowed'
//                                                             : 'text-blue-600 hover:text-blue-900'}`}
//                                                         title={debitNote.sync_status === 'synced' ? "Cannot edit synced debit note" : "Edit"}
//                                                     >
//                                                         <Edit2 size={16} />
//                                                     </button>
//                                                     <button
//                                                         onClick={() => handleSync(debitNote.id)}
//                                                         disabled={debitNote.sync_status === 'synced'}
//                                                         className={`${debitNote.sync_status === 'synced'
//                                                             ? 'text-gray-400 cursor-not-allowed'
//                                                             : 'text-green-600 hover:text-green-900'}`}
//                                                         title={debitNote.sync_status === 'synced' ? "Already synced to Zoho" : "Sync to Zoho"}
//                                                     >
//                                                         <RefreshCcw size={16} />
//                                                     </button>
//                                                     <button
//                                                         onClick={() => handleDelete(debitNote.id)}
//                                                         disabled={debitNote.sync_status === 'synced'}
//                                                         className={`${debitNote.sync_status === 'synced'
//                                                             ? 'text-gray-400 cursor-not-allowed'
//                                                             : 'text-red-600 hover:text-red-900'}`}
//                                                         title={debitNote.sync_status === 'synced' ? "Cannot delete synced debit note" : "Delete"}
//                                                     >
//                                                         <Trash2 size={16} />
//                                                     </button>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     );
//                                 })
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             {/* Pagination */}
//             <div className="mt-6 flex justify-between items-center">
//                 <div className="text-sm text-gray-700">
//                     Showing {(pagination.page - 1) * pagination.limit + 1} to{' '}
//                     {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
//                 </div>
//                 <div className="flex gap-2">
//                     <button
//                         onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
//                         disabled={pagination.page === 1}
//                         className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                         Previous
//                     </button>
//                     <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded">
//                         {pagination.page} / {pagination.totalPages}
//                     </span>
//                     <button
//                         onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
//                         disabled={pagination.page === pagination.totalPages}
//                         className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                         Next
//                     </button>
//                 </div>
//             </div>

//             {/* Form Modal */}
//             {showForm && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
//                         <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
//                             <div>
//                                 <h2 className="text-xl font-semibold">
//                                     {editingDebitNote ? 'Edit Vendor Debit Note' : 'Add New Vendor Debit Note'}
//                                 </h2>
//                                 {currentOrganization?.name && (
//                                     <div className="flex items-center gap-2 mt-1">
//                                         <Building className="w-4 h-4 text-blue-600" />
//                                         <span className="text-sm text-blue-600 font-medium">{currentOrganization.name}</span>
//                                     </div>
//                                 )}
//                                 {editingDebitNote?.sync_status === 'synced' && (
//                                     <div className="flex items-center gap-2 mt-2 px-3 py-2 bg-green-50 border border-green-200 rounded-lg">
//                                         <CheckCircle2 className="w-4 h-4 text-green-600" />
//                                         <span className="text-sm text-green-800 font-medium">
//                                             This debit note has been synced to Zoho Books and cannot be edited
//                                         </span>
//                                     </div>
//                                 )}
//                                 {isLoadingVendor && (
//                                     <span className="text-sm text-blue-600">Loading vendor data...</span>
//                                 )}
//                                 {formData.gst_no && (
//                                     <div className="mt-1 text-sm text-gray-600">
//                                         Vendor State: {getStateFromGST(formData.gst_no)} |
//                                         Transaction: <span className={getTransactionType(formData.gst_no, 'TN').color}>
//                                             {getTransactionType(formData.gst_no, 'TN').type} ({getTransactionType(formData.gst_no, 'TN').taxType})
//                                         </span>
//                                     </div>
//                                 )}
//                             </div>
//                             <button
//                                 onClick={() => {
//                                     setShowForm(false);
//                                     setEditingDebitNote(null);
//                                     resetForm();
//                                 }}
//                                 className="text-gray-400 hover:text-gray-600"
//                             >
//                                 <X size={24} />
//                             </button>
//                         </div>

//                         <div className="p-6 space-y-6">
//                             {/* Basic Information */}
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                 <div className="relative">
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Vendor Name *
//                                     </label>
//                                     <input
//                                         type="text"
//                                         required
//                                         value={formData.vendor_name}
//                                         onChange={(e) => {
//                                             setFormData({ ...formData, vendor_name: e.target.value });
//                                             if (e.target.value.length >= 2) {
//                                                 searchVendors(e.target.value);
//                                                 setShowVendorSuggestions(true);
//                                             } else {
//                                                 setShowVendorSuggestions(false);
//                                             }
//                                         }}
//                                         onFocus={() => {
//                                             if (vendorSuggestions.length > 0) {
//                                                 setShowVendorSuggestions(true);
//                                             }
//                                         }}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         placeholder="Type to search vendors..."
//                                     />

//                                     {/* Vendor Suggestions Dropdown */}
//                                     {showVendorSuggestions && vendorSuggestions.length > 0 && (
//                                         <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
//                                             {vendorSuggestions.map((vendor) => {
//                                                 const vendorState = getStateFromGST(vendor.gst_no);
//                                                 const transactionInfo = getTransactionType(vendor.gst_no, 'TN');

//                                                 return (
//                                                     <div
//                                                         key={vendor.vendor_id}
//                                                         onClick={() => handleVendorSelect(vendor)}
//                                                         className="px-3 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
//                                                     >
//                                                         <div className="font-medium text-gray-900">{vendor.vendor_name}</div>
//                                                         <div className="text-xs text-gray-500">
//                                                             ID: {vendor.vendor_id} | GST: {vendor.gst_no || 'N/A'}
//                                                             {vendor.gst_no && (
//                                                                 <span className={`ml-2 ${transactionInfo.color}`}>
//                                                                     {vendorState} ({transactionInfo.taxType})
//                                                                 </span>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 );
//                                             })}
//                                         </div>
//                                     )}
//                                 </div>
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Vendor ID *
//                                         {formData.vendor_id && (
//                                             <CheckCircle2 size={16} className="inline ml-1 text-green-500" />
//                                         )}
//                                     </label>
//                                     <input
//                                         type="text"
//                                         required
//                                         value={formData.vendor_id}
//                                         onChange={(e) => {
//                                             console.log('🔄 Vendor ID manually changed:', e.target.value);
//                                             setFormData({ ...formData, vendor_id: e.target.value });
//                                         }}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         placeholder="Auto-filled when vendor selected"
//                                     />
//                                 </div>

//                                 {/* Debit Note Reason */}
//                                 <div className="md:col-span-2">
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Reason for Debit Note *
//                                     </label>
//                                     <select
//                                         required
//                                         value={formData.reason}
//                                         onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                     >
//                                         <option value="price_adjustment">Price Adjustment</option>
//                                         <option value="additional_charges">Additional Charges</option>
//                                         <option value="penalty">Penalty</option>
//                                         <option value="quantity_adjustment">Quantity Adjustment</option>
//                                         <option value="other">Other</option>
//                                     </select>
//                                 </div>

//                                 {/* Bill Information Section */}
//                                 <div className="md:col-span-2">
//                                     <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
//                                         <div className="flex justify-between items-center mb-3">
//                                             <h3 className="text-sm font-medium text-gray-700">Bill Information</h3>
//                                             {formData.vendor_id && (
//                                                 <button
//                                                     type="button"
//                                                     onClick={() => setShowBillSelector(true)}
//                                                     className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1"
//                                                 >
//                                                     <FileText size={16} />
//                                                     Select from Bills
//                                                 </button>
//                                             )}
//                                         </div>

//                                         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                                                     Bill Number *
//                                                 </label>
//                                                 <input
//                                                     type="text"
//                                                     required
//                                                     value={formData.bill_number}
//                                                     onChange={(e) => setFormData({ ...formData, bill_number: e.target.value })}
//                                                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                 />
//                                             </div>

//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                                                     Bill Date *
//                                                 </label>
//                                                 <input
//                                                     type="date"
//                                                     required
//                                                     value={formData.bill_date}
//                                                     onChange={(e) => setFormData({ ...formData, bill_date: e.target.value })}
//                                                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                 />
//                                             </div>

//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                                                     Debit Note Amount *
//                                                 </label>
//                                                 <input
//                                                     type="number"
//                                                     step="0.01"
//                                                     required
//                                                     value={formData.debit_note_amount}
//                                                     onChange={(e) => setFormData({ ...formData, debit_note_amount: e.target.value })}
//                                                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Show selected bill info */}
//                                         {formData.selected_bill && (
//                                             <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
//                                                 <div className="flex items-center gap-2 text-sm text-green-800">
//                                                     <CheckCircle2 size={16} />
//                                                     <span className="font-medium">Linked to Bill:</span>
//                                                     <span>{formData.selected_bill.bill_number}</span>
//                                                     <span className="text-green-600">({formData.selected_bill.bill_id})</span>
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Reference Number
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={formData.reference_number}
//                                         onChange={(e) => setFormData({ ...formData, reference_number: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                     />
//                                 </div>
//                             </div>

//                             {/* Tax Information */}
//                             <div className="border-t pt-6">
//                                 <h3 className="text-lg font-medium text-gray-900 mb-4">Tax Information</h3>
//                                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             GST Number
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.gst_no}
//                                             onChange={(e) => setFormData({ ...formData, gst_no: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                             placeholder="Auto-filled from vendor"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             GST Treatment
//                                         </label>
//                                         <select
//                                             value={formData.gst_treatment}
//                                             onChange={(e) => setFormData({ ...formData, gst_treatment: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         >
//                                             <option value="business_gst">Business GST</option>
//                                             <option value="consumer">Consumer</option>
//                                             <option value="overseas">Overseas</option>
//                                         </select>
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Tax Treatment
//                                         </label>
//                                         <select
//                                             value={formData.tax_treatment}
//                                             onChange={(e) => setFormData({ ...formData, tax_treatment: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         >
//                                             <option value="vat_registered">VAT Registered</option>
//                                             <option value="vat_not_registered">VAT Not Registered</option>
//                                             <option value="overseas">Overseas</option>
//                                         </select>
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Source of Supply (Organization)
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.source_of_supply}
//                                             onChange={(e) => setFormData({ ...formData, source_of_supply: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Destination of Supply (Vendor)
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.destination_of_supply}
//                                             onChange={(e) => setFormData({ ...formData, destination_of_supply: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                             placeholder="Auto-filled from vendor GST"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Place of Supply
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.place_of_supply}
//                                             onChange={(e) => setFormData({ ...formData, place_of_supply: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Line Items */}
//                             <div className="border-t pt-6">
//                                 <div className="flex justify-between items-center mb-4">
//                                     <h3 className="text-lg font-medium text-gray-900">Line Items</h3>
//                                     <button
//                                         type="button"
//                                         onClick={addLineItem}
//                                         className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
//                                     >
//                                         <Plus size={16} />
//                                         Add Item
//                                     </button>
//                                 </div>

//                                 <div className="space-y-4">
//                                     {formData.line_items.map((item, index) => (
//                                         <div key={index} className="border border-gray-200 rounded-lg p-4">
//                                             <div className="flex justify-between items-center mb-3">
//                                                 <h4 className="font-medium text-gray-900">Item {index + 1}</h4>
//                                                 {formData.line_items.length > 1 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => removeLineItem(index)}
//                                                         className="text-red-600 hover:text-red-800"
//                                                     >
//                                                         <X size={16} />
//                                                     </button>
//                                                 )}
//                                             </div>

//                                             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
//                                                 <div className="lg:col-span-2">
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Item Name *
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         required
//                                                         value={item.name}
//                                                         onChange={(e) => updateLineItem(index, 'name', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div className="lg:col-span-2">
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Description
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.description}
//                                                         onChange={(e) => updateLineItem(index, 'description', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         HSN/SAC
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.hsn_or_sac}
//                                                         onChange={(e) => updateLineItem(index, 'hsn_or_sac', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Quantity *
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         required
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.quantity}
//                                                         onChange={(e) => updateLineItem(index, 'quantity', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Unit
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.unit}
//                                                         onChange={(e) => updateLineItem(index, 'unit', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Rate *
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         required
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.rate}
//                                                         onChange={(e) => updateLineItem(index, 'rate', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>
//                                             </div>

//                                             {/* Tax Information for Line Item */}
//                                             <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3 pt-3 border-t border-gray-100">
//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         CGST Rate (%)
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.cgst_rate}
//                                                         onChange={(e) => updateLineItem(index, 'cgst_rate', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         SGST Rate (%)
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.sgst_rate}
//                                                         onChange={(e) => updateLineItem(index, 'sgst_rate', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         IGST Rate (%)
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.igst_rate}
//                                                         onChange={(e) => updateLineItem(index, 'igst_rate', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>
//                                             </div>

//                                             {/* Line Item Total */}
//                                             <div className="mt-3 pt-3 border-t border-gray-100">
//                                                 <div className="flex justify-between items-center">
//                                                     <span className="text-sm font-medium text-gray-700">
//                                                         Subtotal: ₹ {((item.quantity || 0) * (item.rate || 0)).toFixed(2)}
//                                                     </span>
//                                                     <span className="text-sm font-medium text-gray-900">
//                                                         Total: ₹ {calculateLineItemTotal(item).toFixed(2)}
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>

//                                 {/* Grand Total */}
//                                 <div className="mt-4 p-4 bg-gray-50 rounded-lg">
//                                     <div className="flex justify-between items-center">
//                                         <span className="text-lg font-medium text-gray-900">Grand Total:</span>
//                                         <span className="text-lg font-bold text-blue-600">
//                                             ₹ {formData.line_items.reduce((total, item) => total + calculateLineItemTotal(item), 0).toFixed(2)}
//                                         </span>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Additional Information */}
//                             <div className="border-t pt-6">
//                                 <h3 className="text-lg font-medium text-gray-900 mb-4">Additional Information</h3>
//                                 <div className="grid grid-cols-1 gap-4">
//                                     <div className="flex items-center space-x-6">
//                                         <label className="flex items-center">
//                                             <input
//                                                 type="checkbox"
//                                                 checked={formData.is_inclusive_tax}
//                                                 onChange={(e) => setFormData({ ...formData, is_inclusive_tax: e.target.checked })}
//                                                 className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//                                             />
//                                             <span className="ml-2 text-sm text-gray-700">Inclusive Tax</span>
//                                         </label>
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Notes
//                                         </label>
//                                         <textarea
//                                             rows={3}
//                                             value={formData.notes}
//                                             onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                             placeholder="Additional notes about this vendor debit note..."
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Form Actions */}
//                             <div className="border-t pt-6 flex justify-end gap-3">
//                                 <button
//                                     type="button"
//                                     onClick={() => {
//                                         setShowForm(false);
//                                         setEditingDebitNote(null);
//                                         resetForm();
//                                     }}
//                                     className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
//                                 >
//                                     {editingDebitNote?.sync_status === 'synced' ? 'Close' : 'Cancel'}
//                                 </button>
//                                 {editingDebitNote?.sync_status !== 'synced' && (
//                                     <button
//                                         type="button"
//                                         onClick={handleSubmit}
//                                         disabled={isLoading || isLoadingVendor}
//                                         className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                                     >
//                                         <Save size={16} />
//                                         {isLoading ? 'Saving...' : editingDebitNote ? 'Update Debit Note' : 'Create Debit Note'}
//                                     </button>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Bill Selector Modal */}
//             {showBillSelector && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-lg max-w-4xl w-full max-h-[80vh] overflow-hidden">
//                         <div className="px-6 py-4 border-b border-gray-200">
//                             <div className="flex justify-between items-center">
//                                 <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
//                                     <FileText className="w-5 h-5 text-blue-600" />
//                                     Select Bill for {formData.vendor_name}
//                                 </h3>
//                                 <button
//                                     onClick={() => setShowBillSelector(false)}
//                                     className="text-gray-400 hover:text-gray-600"
//                                 >
//                                     <X size={24} />
//                                 </button>
//                             </div>
//                         </div>

//                         <div className="p-6 overflow-y-auto max-h-[60vh]">
//                             {isLoadingBills ? (
//                                 <div className="flex items-center justify-center py-8">
//                                     <RefreshCcw className="w-8 h-8 text-blue-600 animate-spin" />
//                                     <span className="ml-2 text-gray-600">Loading bills...</span>
//                                 </div>
//                             ) : vendorBills.length === 0 ? (
//                                 <div className="text-center py-8">
//                                     <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
//                                     <p className="text-gray-500 mb-2">No bills found for this vendor</p>
//                                     <p className="text-sm text-gray-400">You can still create a debit note by entering bill details manually</p>
//                                 </div>
//                             ) : (
//                                 <div className="space-y-3">
//                                     <div className="text-sm text-gray-600 mb-4">
//                                         Select a bill to link with this vendor debit note:
//                                     </div>
//                                     {vendorBills.map((bill) => (
//                                         <div
//                                             key={bill.bill_id}
//                                             className={`border rounded-lg p-4 cursor-pointer transition-all hover:shadow-md ${formData.zoho_bill_id === bill.bill_id
//                                                 ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-200'
//                                                 : 'border-gray-200 hover:border-blue-300 hover:bg-gray-50'
//                                                 }`}
//                                             onClick={() => handleBillSelect(bill)}
//                                         >
//                                             <div className="flex items-center justify-between">
//                                                 <div className="flex-1">
//                                                     <div className="flex items-center gap-3">
//                                                         <FileText className="w-5 h-5 text-gray-400" />
//                                                         <div>
//                                                             <h4 className="font-medium text-gray-900">{bill.bill_number}</h4>
//                                                             <p className="text-sm text-gray-500">ID: {bill.bill_id}</p>
//                                                         </div>
//                                                     </div>
//                                                     <div className="mt-2 flex gap-6 text-sm text-gray-600">
//                                                         <div className="flex items-center gap-1">
//                                                             <Calendar className="w-4 h-4" />
//                                                             <span>{new Date(bill.date).toLocaleDateString()}</span>
//                                                         </div>
//                                                         <span>💰 Total: ₹ {parseFloat(bill.total || 0).toFixed(2)}</span>
//                                                         <span>📊 Balance: ₹ {parseFloat(bill.balance || 0).toFixed(2)}</span>
//                                                         <span className={`px-2 py-1 rounded text-xs ${bill.status === 'paid' ? 'bg-green-100 text-green-800' :
//                                                             bill.status === 'overdue' ? 'bg-red-100 text-red-800' :
//                                                                 'bg-yellow-100 text-yellow-800'
//                                                             }`}>
//                                                             {bill.status}
//                                                         </span>
//                                                     </div>
//                                                 </div>
//                                                 <div className="flex items-center gap-2">
//                                                     {formData.zoho_bill_id === bill.bill_id ? (
//                                                         <div className="flex items-center gap-2">
//                                                             <CheckCircle2 className="w-5 h-5 text-green-600" />
//                                                             <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full font-medium">
//                                                                 Selected
//                                                             </span>
//                                                         </div>
//                                                     ) : (
//                                                         <div className="text-blue-600 hover:text-blue-800">
//                                                             <span className="text-xs bg-blue-100 hover:bg-blue-200 px-3 py-1 rounded-full font-medium transition-colors">
//                                                                 Select
//                                                             </span>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>

//                         <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
//                             <div className="flex justify-between items-center">
//                                 <div className="text-sm text-gray-600">
//                                     {vendorBills.length > 0 && (
//                                         <span>{vendorBills.length} bill{vendorBills.length !== 1 ? 's' : ''} available</span>
//                                     )}
//                                 </div>
//                                 <div className="flex gap-3">
//                                     <button
//                                         onClick={() => formData.vendor_id && fetchVendorBills(formData.vendor_id)}
//                                         disabled={isLoadingBills || !formData.vendor_id}
//                                         className="flex items-center gap-2 px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
//                                     >
//                                         <RefreshCcw className={`w-4 h-4 ${isLoadingBills ? 'animate-spin' : ''}`} />
//                                         Refresh
//                                     </button>
//                                     <button
//                                         onClick={() => setShowBillSelector(false)}
//                                         className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700"
//                                     >
//                                         Close
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default VendorCreditManagement;



import { useState, useEffect, useCallback } from 'react';
import { Plus, Edit2, Trash2, RefreshCcw, Save, X, Search, Filter, AlertCircle, CheckCircle, CheckCircle2, MapPin, Building, FileText, Calendar, Clock, XCircle } from 'lucide-react';

const VendorCreditManagement = () => {
    const [debitNotes, setDebitNotes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingVendor, setIsLoadingVendor] = useState(false);
    const [isLoadingBills, setIsLoadingBills] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [editingDebitNote, setEditingDebitNote] = useState(null);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [filter, setFilter] = useState('all');
    const [vendorSuggestions, setVendorSuggestions] = useState([]);
    const [showVendorSuggestions, setShowVendorSuggestions] = useState(false);
    const [vendorBills, setVendorBills] = useState([]);
    const [showBillSelector, setShowBillSelector] = useState(false);

    const [formData, setFormData] = useState({
        vendor_name: '',
        bill_number: '',
        bill_date: '',
        balance: '',
        debit_note_amount: '',
        vendor_id: '',
        currency_id: '3000000000083',
        vat_treatment: '',
        vendor_debit_number: '',
        gst_treatment: 'business_gst',
        tax_treatment: 'vat_registered',
        gst_no: '',
        source_of_supply: 'TN',
        destination_of_supply: 'TN',
        place_of_supply: 'DU',
        pricebook_id: '',
        reference_number: '',
        is_update_customer: false,
        exchange_rate: 1,
        is_inclusive_tax: false,
        location_id: '',
        line_items: [{
            item_id: '',
            name: '',
            description: '',
            quantity: 1,
            unit: 'Nos',
            rate: 0,
            tax_id: '',
            hsn_or_sac: '',
            cgst_rate: 0,
            sgst_rate: 0,
            igst_rate: 0,
            total_tax: 0
        }],
        notes: '',
        custom_fields: [],
        company_id: '1',
        autoSync: false,
        zoho_bill_id: '',
        selected_bill: null,
        reason: 'price_adjustment'
    });

    // Organization state
    const [currentOrganization, setCurrentOrganization] = useState({
        organization_id: '',
        name: ''
    });

    const API_BASE_URL = 'https://api.zapbooksai.subraps.com/api';

    // Get authentication headers
    const getAuthHeaders = () => {
        const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
        return {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
        };
    };

    // NEW: Check if debit note can be edited based on approval status
    const canEdit = useCallback((debitNote) => {
        const status = debitNote.approver_status || debitNote.approvalInfo?.status;
        console.log('Edit check for debit note', debitNote.id, 'status:', status);
        // Only allow editing if explicitly approved or no status (auto-approved)
        return status === 'approved' || !status;
    }, []);

    // NEW: Check if debit note can be synced based on approval status
    const canSync = useCallback((debitNote) => {
        const status = debitNote.approver_status || debitNote.approvalInfo?.status;
        console.log('Sync check for debit note', debitNote.id, 'status:', status);
        // Only allow syncing if explicitly approved or no status (auto-approved)
        return status === 'approved' || !status;
    }, []);

    // NEW: Get approval status display component
    const getApprovalStatusDisplay = useCallback((debitNote) => {
        const status = debitNote.approver_status || debitNote.approvalInfo?.status;
        console.log('Status display for debit note', debitNote.id, '- Database status:', debitNote.approver_status, '- User type:', debitNote.user_type, '- Final status:', status);

        if (status === 'approved') {
            return (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    <CheckCircle className="w-3 h-3 mr-1" />
                    Approved
                    {debitNote.approved_by && <span className="ml-1">by {debitNote.approved_by}</span>}
                </span>
            );
        }

        if (status === 'rejected') {
            return (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                    <XCircle className="w-3 h-3 mr-1" />
                    Rejected
                </span>
            );
        }

        if (status === 'pending_approval') {
            return (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                    <Clock className="w-3 h-3 mr-1" />
                    Pending Approval
                </span>
            );
        }

        // Default to auto-approved for approver users
        return (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                <CheckCircle className="w-3 h-3 mr-1" />
                Auto-Approved
            </span>
        );
    }, []);

    // Fetch current organization
    const fetchCurrentOrganization = async () => {
        try {
            console.log('🔍 Fetching current organization...');
            const response = await fetch(`${API_BASE_URL}/token/status`, {
                headers: getAuthHeaders()
            });
            const result = await response.json();

            if (result.success && result.data.current_organization) {
                const org = result.data.current_organization;
                console.log('✅ Current organization fetched:', org);
                setCurrentOrganization(org);
                return org.organization_id;
            } else {
                console.error('❌ No current organization found');
                throw new Error('No current organization found');
            }
        } catch (error) {
            console.error('❌ Error fetching current organization:', error);
        }
    };

    // Helper function to extract state code from GST number
    const getStateFromGST = (gstNumber) => {
        if (!gstNumber || gstNumber.length < 2) return null;

        const stateCode = gstNumber.substring(0, 2);
        const gstStateMapping = {
            '01': 'Jammu & Kashmir', '02': 'Himachal Pradesh', '03': 'Punjab', '04': 'Chandigarh',
            '05': 'Uttarakhand', '06': 'Haryana', '07': 'Delhi', '08': 'Rajasthan',
            '09': 'Uttar Pradesh', '10': 'Bihar', '11': 'Sikkim', '12': 'Arunachal Pradesh',
            '13': 'Nagaland', '14': 'Manipur', '15': 'Mizoram', '16': 'Tripura',
            '17': 'Meghalaya', '18': 'Assam', '19': 'West Bengal', '20': 'Jharkhand',
            '21': 'Odisha', '22': 'Chhattisgarh', '23': 'Madhya Pradesh', '24': 'Gujarat',
            '25': 'Daman & Diu', '26': 'Dadra & Nagar Haveli', '27': 'Maharashtra',
            '28': 'Andhra Pradesh', '29': 'Karnataka', '30': 'Goa', '31': 'Lakshadweep',
            '32': 'Kerala', '33': 'Tamil Nadu', '34': 'Puducherry', '35': 'Andaman & Nicobar',
            '36': 'Telangana', '37': 'Andhra Pradesh', '38': 'Ladakh'
        };

        return gstStateMapping[stateCode] || `State Code: ${stateCode}`;
    };

    // Determine transaction type based on GST states
    const getTransactionType = (vendorGST, orgState = 'TN') => {
        if (!vendorGST) return { type: 'Unknown', taxType: 'GST' };

        const vendorStateCode = vendorGST.substring(0, 2);
        const orgStateCode = orgState === 'TN' ? '33' : '';

        const isIntraState = vendorStateCode === orgStateCode;

        return {
            type: isIntraState ? 'Intra-State' : 'Inter-State',
            taxType: isIntraState ? 'CGST+SGST' : 'IGST',
            color: isIntraState ? 'text-green-600' : 'text-blue-600'
        };
    };

    // Search vendors in Zoho Books
    const searchVendors = async (searchTerm) => {
        if (!searchTerm || searchTerm.length < 2) {
            setVendorSuggestions([]);
            return;
        }

        try {
            setIsLoadingVendor(true);
            console.log('🔍 Searching vendors for term:', searchTerm);
            console.log('🏢 Using organization ID:', currentOrganization?.organization_id);

            const searchParams = new URLSearchParams({
                query: searchTerm
            });

            if (currentOrganization?.organization_id) {
                searchParams.append('organization_id', currentOrganization.organization_id);
            }

            const response = await fetch(`${API_BASE_URL}/zoho/vendors/search?${searchParams}`, {
                headers: getAuthHeaders()
            });

            console.log('📡 Vendor search response status:', response.status);

            const result = await response.json();
            console.log('📊 Vendor search result:', result);

            if (result.success && result.data.vendors) {
                console.log('✅ Found vendors:', result.data.vendors.length);
                console.log('📋 First vendor data:', result.data.vendors[0]);
                console.log('🏢 Search performed in org:', result.data.debug?.organizationId);

                setVendorSuggestions(result.data.vendors.slice(0, 10));
            } else {
                console.warn('⚠️ No vendors found or API error:', result.message);
                console.log('🏢 Organization used:', result.data?.debug?.organizationId);
                setVendorSuggestions([]);
            }
        } catch (error) {
            console.error('❌ Error searching vendors:', error);
            setVendorSuggestions([]);
        } finally {
            setIsLoadingVendor(false);
        }
    };

    // Get vendor details from Zoho Books
    const getVendorDetails = async (vendorId) => {
        try {
            setIsLoadingVendor(true);
            console.log('🔍 Fetching vendor details for ID:', vendorId);
            console.log('🏢 Using organization ID:', currentOrganization?.organization_id);

            const detailsParams = new URLSearchParams();
            if (currentOrganization?.organization_id) {
                detailsParams.append('organization_id', currentOrganization.organization_id);
            }

            const response = await fetch(`${API_BASE_URL}/zoho/vendors/${vendorId}?${detailsParams}`, {
                headers: getAuthHeaders()
            });

            console.log('📡 Vendor details response status:', response.status);

            const result = await response.json();
            console.log('📊 Vendor details result:', result);

            if (result.success && result.data.vendor) {
                console.log('✅ Vendor details fetched successfully:', result.data.vendor);
                console.log('🏢 Details fetched from org:', result.data.debug?.organizationId);
                return result.data.vendor;
            } else {
                console.warn('⚠️ Failed to fetch vendor details:', result.message);
                console.log('🏢 Organization used:', result.data?.debug?.organizationId);
            }
            return null;
        } catch (error) {
            console.error('❌ Error fetching vendor details:', error);
            return null;
        } finally {
            setIsLoadingVendor(false);
        }
    };

    // Fetch vendor bills
    const fetchVendorBills = async (vendorId) => {
        if (!vendorId) return;

        try {
            setIsLoadingBills(true);
            console.log('🔍 Fetching bills for vendor ID:', vendorId);
            console.log('🏢 Using organization ID:', currentOrganization?.organization_id);

            const billsParams = new URLSearchParams();
            if (currentOrganization?.organization_id) {
                billsParams.append('organization_id', currentOrganization.organization_id);
            }

            const response = await fetch(`${API_BASE_URL}/zoho/vendors/${vendorId}/bills?${billsParams}`, {
                headers: getAuthHeaders()
            });

            console.log('📡 Vendor bills response status:', response.status);

            const result = await response.json();
            console.log('📊 Vendor bills result:', result);

            if (result.success && result.data.bills) {
                console.log('✅ Found bills:', result.data.bills.length);
                console.log('📋 Bills data:', result.data.bills);
                setVendorBills(result.data.bills);
                return result.data.bills;
            } else {
                console.warn('⚠️ No bills found or API error:', result.message);
                setVendorBills([]);
                return [];
            }
        } catch (error) {
            console.error('❌ Error fetching vendor bills:', error);
            setVendorBills([]);
            return [];
        } finally {
            setIsLoadingBills(false);
        }
    };

    // Handle vendor selection
    const handleVendorSelect = async (vendor) => {
        console.log('🔄 Vendor selected:', vendor);

        setFormData(prev => ({
            ...prev,
            vendor_name: vendor.vendor_name,
            vendor_id: vendor.vendor_id
        }));

        setShowVendorSuggestions(false);
        setVendorSuggestions([]);

        try {
            setIsLoadingVendor(true);
            const vendorDetails = await getVendorDetails(vendor.vendor_id);

            if (vendorDetails) {
                console.log('✅ Vendor details fetched:', vendorDetails);

                let destinationState = null;
                let placeOfSupply = null;

                if (vendorDetails.gst_no) {
                    const gstStateCode = vendorDetails.gst_no.substring(0, 2);
                    const stateCodeMapping = {
                        '33': 'TN', '24': 'GJ', '27': 'MH', '29': 'KA', '07': 'DL',
                        '32': 'KL', '28': 'AP', '36': 'TG', '19': 'WB', '09': 'UP'
                    };
                    destinationState = stateCodeMapping[gstStateCode] || gstStateCode;
                    placeOfSupply = destinationState;
                }

                setFormData(prev => ({
                    ...prev,
                    vendor_name: vendorDetails.vendor_name,
                    vendor_id: vendorDetails.vendor_id,
                    gst_no: vendorDetails.gst_no || '',
                    gst_treatment: vendorDetails.gst_treatment || 'business_gst',
                    tax_treatment: vendorDetails.tax_treatment || 'vat_registered',
                    place_of_supply: placeOfSupply || vendorDetails.place_of_supply || prev.place_of_supply,
                    source_of_supply: 'TN',
                    destination_of_supply: destinationState || vendorDetails.billing_address?.state_code || prev.destination_of_supply,
                    currency_id: vendorDetails.currency_id || prev.currency_id
                }));

                console.log('✅ Form updated with vendor details');
            } else {
                console.warn('⚠️ No vendor details returned from API');
            }

            await fetchVendorBills(vendor.vendor_id);

        } catch (error) {
            console.error('❌ Error in handleVendorSelect:', error);
            setFormData(prev => ({
                ...prev,
                vendor_name: vendor.vendor_name,
                vendor_id: vendor.vendor_id
            }));
        } finally {
            setIsLoadingVendor(false);
        }
    };

    // Handle bill selection
    const handleBillSelect = (bill) => {
        setFormData(prev => ({
            ...prev,
            bill_number: bill.bill_number,
            bill_date: bill.date,
            balance: bill.balance || bill.total,
            zoho_bill_id: bill.bill_id,
            selected_bill: bill
        }));
        setShowBillSelector(false);
    };

    // Enhanced line item handling for existing data
    const parseLineItemsFromDatabase = (lineItemsData) => {
        if (!lineItemsData) return getDefaultLineItem();

        try {
            let parsedItems = [];

            console.log('🔍 Raw line items data:', lineItemsData);

            if (typeof lineItemsData === 'string') {
                try {
                    parsedItems = JSON.parse(lineItemsData);
                } catch (parseError) {
                    console.error('❌ JSON parse error:', parseError);
                    return getDefaultLineItem();
                }
            } else if (Array.isArray(lineItemsData)) {
                parsedItems = lineItemsData;
            } else if (typeof lineItemsData === 'object') {
                parsedItems = [lineItemsData];
            }

            if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
                return getDefaultLineItem();
            }

            const formattedItems = parsedItems.map((item) => ({
                item_id: item.item_id || '',
                name: item.name || '',
                description: item.description || item.name || '',
                quantity: parseFloat(item.quantity) || 1,
                unit: item.unit || 'Nos',
                rate: parseFloat(item.rate) || 0,
                tax_id: item.tax_id || '',
                hsn_or_sac: item.hsn_or_sac || '',
                cgst_rate: parseFloat(item.cgst_rate) || 0,
                sgst_rate: parseFloat(item.sgst_rate) || 0,
                igst_rate: parseFloat(item.igst_rate) || 0,
                total_tax: parseFloat(item.total_tax) || 0
            }));

            return formattedItems;

        } catch (error) {
            console.error('❌ Error parsing line items:', error);
            return getDefaultLineItem();
        }
    };

    const getDefaultLineItem = () => [{
        item_id: '',
        name: '',
        description: '',
        quantity: 1,
        unit: 'Nos',
        rate: 0,
        tax_id: '',
        hsn_or_sac: '',
        cgst_rate: 0,
        sgst_rate: 0,
        igst_rate: 0,
        total_tax: 0
    }];

    // Calculate line item total including tax
    const calculateLineItemTotal = (item) => {
        const subtotal = (parseFloat(item.quantity) || 0) * (parseFloat(item.rate) || 0);
        const totalTax = parseFloat(item.total_tax) || 0;
        return subtotal + totalTax;
    };

    // Initialize component
    useEffect(() => {
        const initializeComponent = async () => {
            try {
                await fetchCurrentOrganization();
            } catch (error) {
                console.error('Failed to initialize component:', error);
            }
        };

        initializeComponent();
    }, []);

    useEffect(() => {
        if (currentOrganization?.organization_id) {
            fetchDebitNotes();
        }
    }, [pagination.page, searchTerm, filter, currentOrganization?.organization_id]);

    const fetchDebitNotes = async () => {
        if (!currentOrganization?.organization_id) {
            console.log('❌ No organization ID available, skipping load');
            return;
        }
        setIsLoading(true);
        try {
            const params = new URLSearchParams({
                page: pagination.page,
                limit: pagination.limit,
                company_id: currentOrganization?.organization_id
            });

            const response = await fetch(`${API_BASE_URL}/vendor-debit-notes?${params}`, {
                headers: getAuthHeaders()
            });
            const result = await response.json();

            if (result.success) {
                setDebitNotes(result.data.debitNotes);
                setPagination(prev => ({
                    ...prev,
                    total: result.data.total,
                    totalPages: result.data.totalPages
                }));
            }
        } catch (error) {
            console.error('Error fetching debit notes:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const getCurrentUserId = () => {
        // Implement based on your auth system
        // Example implementations:

        // From localStorage
        const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
        return user.id;

        // Or from sessionStorage
        // const user = JSON.parse(sessionStorage.getItem('user') || '{}');
        // return user.id;

        // Or decode from token
        // const token = localStorage.getItem('authToken');
        // if (token) {
        //     const payload = JSON.parse(atob(token.split('.')[1]));
        //     return payload.userId;
        // }

        return null;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const { selected_bill, ...formDataToSend } = formData;

            const formattedData = {
                ...formDataToSend,
                bill_date: formDataToSend.bill_date || null,
                company_id: currentOrganization?.organization_id,
                user_access_id: getCurrentUserId()
            };

            Object.keys(formattedData).forEach(key => {
                if (formattedData[key] === '' || formattedData[key] === undefined) {
                    formattedData[key] = null;
                }
            });

            console.log('📤 Sending formatted data:', formattedData);

            const url = editingDebitNote ? `${API_BASE_URL}/vendor-debit-notes/${editingDebitNote.id}` : `${API_BASE_URL}/vendor-debit-notes`;
            const method = editingDebitNote ? 'PUT' : 'POST';

            const response = await fetch(url, {
                method,
                headers: getAuthHeaders(),
                body: JSON.stringify(formattedData),
            });

            const result = await response.json();

            if (result.success) {
                setShowForm(false);
                setEditingDebitNote(null);
                resetForm();
                fetchDebitNotes();
                alert(editingDebitNote ? 'Debit note updated successfully!' : 'Debit note created successfully!');
            } else {
                alert('Error: ' + result.message);
            }
        } catch (error) {
            console.error('Error saving debit note:', error);
            alert('Error saving debit note');
        } finally {
            setIsLoading(false);
        }
    };

    // UPDATED: Handle edit with approval check
    const handleEdit = async (debitNote) => {
        console.log('Editing debit note:', debitNote);

        // NEW: Check if debit note can be edited
        if (!canEdit(debitNote)) {
            const status = debitNote.approver_status || debitNote.approvalInfo?.status;
            let message = 'This debit note cannot be edited - ';
            if (status === 'pending_approval') {
                message += 'pending approval';
            } else if (status === 'rejected') {
                message += 'rejected';
            } else {
                message += 'not approved';
            }
            alert(message);
            return;
        }

        if (debitNote.zoho_debit_id) {
            alert('This debit note has already been synced to Zoho Books and cannot be edited to maintain data consistency.');
            return;
        }

        setEditingDebitNote(debitNote);
        setIsLoadingVendor(true);

        try {
            let freshDebitNote = debitNote;
            try {
                const debitNoteResponse = await fetch(`${API_BASE_URL}/vendor-debit-notes/${debitNote.id}`, {
                    headers: getAuthHeaders()
                });
                if (debitNoteResponse.ok) {
                    const debitNoteResult = await debitNoteResponse.json();
                    if (debitNoteResult.success) {
                        freshDebitNote = debitNoteResult.data;
                    }
                }
            } catch (debitNoteError) {
                console.warn('Could not fetch fresh debit note data:', debitNoteError);
            }

            const dbDate = freshDebitNote.bill_date ? new Date(freshDebitNote.bill_date) : null;
            const localDate = dbDate ?
                `${dbDate.getFullYear()}-${String(dbDate.getMonth() + 1).padStart(2, '0')}-${String(dbDate.getDate()).padStart(2, '0')}` :
                '';

            const parsedLineItems = parseLineItemsFromDatabase(freshDebitNote.line_items);

            setFormData({
                ...freshDebitNote,
                bill_date: localDate,
                line_items: parsedLineItems,
                autoSync: false,
                company_id: currentOrganization?.organization_id,
                selected_bill: freshDebitNote.zoho_bill_id ? {
                    bill_id: freshDebitNote.zoho_bill_id,
                    bill_number: freshDebitNote.bill_number
                } : null
            });

            if (freshDebitNote.vendor_id) {
                console.log('🔄 Refreshing vendor details for ID:', freshDebitNote.vendor_id);

                await fetchVendorBills(freshDebitNote.vendor_id);

                const vendorDetails = await getVendorDetails(freshDebitNote.vendor_id);

                if (vendorDetails) {
                    let destinationState = null;
                    let placeOfSupply = null;

                    if (vendorDetails.gst_no) {
                        const gstStateCode = vendorDetails.gst_no.substring(0, 2);
                        const stateCodeMapping = {
                            '33': 'TN', '24': 'GJ', '27': 'MH', '29': 'KA', '07': 'DL',
                            '32': 'KL', '28': 'AP', '36': 'TG', '19': 'WB', '09': 'UP'
                        };
                        destinationState = stateCodeMapping[gstStateCode] || gstStateCode;
                        placeOfSupply = destinationState;
                    }

                    setFormData(prev => ({
                        ...prev,
                        vendor_name: vendorDetails.vendor_name,
                        gst_no: vendorDetails.gst_no || prev.gst_no,
                        gst_treatment: vendorDetails.gst_treatment || prev.gst_treatment,
                        tax_treatment: vendorDetails.tax_treatment || prev.tax_treatment,
                        place_of_supply: placeOfSupply || vendorDetails.place_of_supply || prev.place_of_supply,
                        source_of_supply: 'TN',
                        destination_of_supply: destinationState || vendorDetails.billing_address?.state_code || prev.destination_of_supply,
                        currency_id: vendorDetails.currency_id || prev.currency_id
                    }));
                }
            }

        } catch (error) {
            console.error('Error in handleEdit:', error);
        } finally {
            setIsLoadingVendor(false);
            setShowForm(true);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this debit note?')) {
            try {
                const response = await fetch(`${API_BASE_URL}/vendor-debit-notes/${id}`, {
                    method: 'DELETE',
                    headers: getAuthHeaders()
                });

                const result = await response.json();

                if (result.success) {
                    fetchDebitNotes();
                    alert('Debit note deleted successfully!');
                } else {
                    alert('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Error deleting debit note:', error);
                alert('Error deleting debit note');
            }
        }
    };

    // UPDATED: Handle sync with approval check
    const handleSync = async (id) => {
        try {
            // Find the debit note to check approval status
            const debitNote = debitNotes.find(dn => dn.id === id);

            // NEW: Check if debit note can be synced
            if (!canSync(debitNote)) {
                const status = debitNote.approver_status || debitNote.approvalInfo?.status;
                let message = 'This debit note cannot be synced - ';
                if (status === 'pending_approval') {
                    message += 'pending approval';
                } else if (status === 'rejected') {
                    message += 'rejected';
                } else {
                    message += 'not approved';
                }
                alert(message);
                return;
            }

            const syncPayload = {
                organization_id: currentOrganization?.organization_id
            };

            console.log('🔄 Syncing with organization ID:', currentOrganization?.organization_id);

            const response = await fetch(`${API_BASE_URL}/vendor-debit-notes/${id}/sync`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify(syncPayload)
            });

            const result = await response.json();

            if (result.success) {
                fetchDebitNotes();
                alert('Debit note synced to Zoho Books successfully!');
                console.log('✅ Sync result:', result.data);
            } else {
                alert('Sync error: ' + result.message);
                console.error('❌ Sync error:', result.message);
            }
        } catch (error) {
            console.error('Error syncing debit note:', error);
            alert('Error syncing debit note');
        }
    };

    const resetForm = () => {
        setFormData({
            vendor_name: '',
            bill_number: '',
            bill_date: '',
            balance: '',
            debit_note_amount: '',
            vendor_id: '',
            currency_id: '3000000000083',
            vat_treatment: '',
            vendor_debit_number: '',
            gst_treatment: 'business_gst',
            tax_treatment: 'vat_registered',
            gst_no: '',
            source_of_supply: 'TN',
            destination_of_supply: 'TN',
            place_of_supply: 'DU',
            pricebook_id: '',
            reference_number: '',
            is_update_customer: false,
            exchange_rate: 1,
            is_inclusive_tax: false,
            location_id: '',
            line_items: getDefaultLineItem(),
            notes: '',
            custom_fields: [],
            company_id: currentOrganization?.organization_id || '1',
            autoSync: false,
            zoho_bill_id: '',
            selected_bill: null,
            reason: 'price_adjustment'
        });
        setVendorSuggestions([]);
        setShowVendorSuggestions(false);
        setVendorBills([]);
        setShowBillSelector(false);
    };

    const addLineItem = () => {
        setFormData(prev => ({
            ...prev,
            line_items: [...prev.line_items, {
                item_id: '',
                name: '',
                description: '',
                quantity: 1,
                unit: 'Nos',
                rate: 0,
                tax_id: '',
                hsn_or_sac: '',
                cgst_rate: 0,
                sgst_rate: 0,
                igst_rate: 0,
                total_tax: 0
            }]
        }));
    };

    const removeLineItem = (index) => {
        setFormData(prev => ({
            ...prev,
            line_items: prev.line_items.filter((_, i) => i !== index)
        }));
    };

    const updateLineItem = (index, field, value) => {
        setFormData(prev => ({
            ...prev,
            line_items: prev.line_items.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        }));
    };

    const getSyncStatusBadge = (status) => {
        const badges = {
            'pending': 'bg-yellow-100 text-yellow-800',
            'synced': 'bg-green-100 text-green-800',
            'error': 'bg-red-100 text-red-800'
        };
        return badges[status] || 'bg-gray-100 text-gray-800';
    };

    const getReasonBadge = (reason) => {
        const badges = {
            'price_adjustment': 'bg-blue-100 text-blue-800',
            'additional_charges': 'bg-purple-100 text-purple-800',
            'penalty': 'bg-red-100 text-red-800',
            'quantity_adjustment': 'bg-orange-100 text-orange-800',
            'other': 'bg-gray-100 text-gray-800'
        };
        const labels = {
            'price_adjustment': 'Price Adjustment',
            'additional_charges': 'Additional Charges',
            'penalty': 'Penalty',
            'quantity_adjustment': 'Quantity Adjustment',
            'other': 'Other'
        };
        return { badge: badges[reason] || 'bg-gray-100 text-gray-800', label: labels[reason] || 'Other' };
    };

    const filteredDebitNotes = debitNotes.filter(debitNote => {
        const matchesSearch = debitNote.vendor_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            debitNote.bill_number.toLowerCase().includes(searchTerm.toLowerCase());

        if (filter === 'all') return matchesSearch;
        if (filter === 'approved') return matchesSearch && (debitNote.approver_status === 'approved' || !debitNote.approver_status);
        if (filter === 'pending') return matchesSearch && debitNote.approver_status === 'pending_approval';
        if (filter === 'rejected') return matchesSearch && debitNote.approver_status === 'rejected';
        return matchesSearch && debitNote.sync_status === filter;
    });

    if (!currentOrganization.organization_id) {
        return (
            <div className="max-w-7xl mx-auto p-6">
                <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                    <div className="flex items-center gap-3">
                        <div className="text-red-600">⚠️</div>
                        <div>
                            <h3 className="text-red-800 font-semibold">Organization Not Found</h3>
                            <p className="text-red-700 mt-1">
                                Unable to load the current organization. Please ensure you're logged in to Zoho Books
                                and have selected an organization.
                            </p>
                            <button
                                onClick={fetchCurrentOrganization}
                                className="mt-3 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
                            >
                                Retry
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-7xl mx-auto p-6">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h1 className="text-3xl font-bold text-gray-900">Vendor Debit Note Management</h1>
                    {currentOrganization?.name && (
                        <div className="flex items-center gap-2 mt-2">
                            <Building className="w-4 h-4 text-blue-600" />
                            <span className="text-sm text-gray-600">
                                Organization: <span className="font-medium text-blue-600">{currentOrganization.name}</span>
                            </span>
                        </div>
                    )}
                </div>
                <button
                    onClick={() => {
                        resetForm();
                        setShowForm(true);
                    }}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                >
                    <Plus size={20} />
                    Add Debit Note
                </button>
            </div>

            {/* Search and Filter */}
            <div className="mb-6 flex gap-4">
                <div className="flex-1 relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                    <input
                        type="text"
                        placeholder="Search by vendor name or bill number..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                </div>
                <div className="flex items-center gap-2">
                    <Filter size={20} className="text-gray-400" />
                    <select
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                        <option value="all">All Status</option>
                        <option value="approved">Approved</option>
                        <option value="pending">Pending Approval</option>
                        <option value="rejected">Rejected</option>
                        <option value="synced">Synced</option>
                        <option value="error">Sync Error</option>
                    </select>
                </div>
            </div>

            {/* Debit Notes Table */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vendor</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bill Info</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tax Info</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Approval Status</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sync Status</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {isLoading ? (
                                <tr>
                                    <td colSpan="9" className="px-6 py-4 text-center text-gray-500">Loading...</td>
                                </tr>
                            ) : filteredDebitNotes.length === 0 ? (
                                <tr>
                                    <td colSpan="9" className="px-6 py-4 text-center text-gray-500">No debit notes found</td>
                                </tr>
                            ) : (
                                filteredDebitNotes.map((debitNote) => {
                                    const transactionInfo = getTransactionType(debitNote.gst_no, 'TN');
                                    const vendorState = getStateFromGST(debitNote.gst_no);
                                    const reasonInfo = getReasonBadge(debitNote.reason);

                                    return (
                                        <tr key={debitNote.id} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center">
                                                    <div>
                                                        <div className="text-sm font-medium text-gray-900">{debitNote.vendor_name}</div>
                                                        <div className="flex items-center gap-1 text-xs text-gray-500">
                                                            {debitNote.vendor_id ? (
                                                                <>
                                                                    <CheckCircle2 size={12} className="text-green-500" />
                                                                    <span>ID: {debitNote.vendor_id}</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <AlertCircle size={12} className="text-yellow-500" />
                                                                    <span className="text-yellow-600">Missing ID</span>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">{debitNote.bill_number}</div>
                                                {debitNote.zoho_bill_id && (
                                                    <div className="flex items-center gap-1 text-xs text-green-600">
                                                        <FileText size={12} />
                                                        <span>Linked to Zoho</span>
                                                    </div>
                                                )}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {debitNote.bill_date ? new Date(debitNote.bill_date).toLocaleDateString() : '-'}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                ₹ {parseFloat(debitNote.debit_note_amount || 0).toFixed(2)}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm">
                                                    {debitNote.gst_no ? (
                                                        <div>
                                                            <div className="flex items-center gap-1">
                                                                <Building size={12} className="text-gray-400" />
                                                                <span className="text-xs font-mono">{debitNote.gst_no}</span>
                                                            </div>
                                                            <div className="flex items-center gap-1 mt-1">
                                                                <MapPin size={12} className="text-gray-400" />
                                                                <span className="text-xs text-gray-600">{vendorState}</span>
                                                            </div>
                                                            <div className={`text-xs font-medium mt-1 ${transactionInfo.color}`}>
                                                                {transactionInfo.type} ({transactionInfo.taxType})
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-center gap-1">
                                                            <AlertCircle size={12} className="text-yellow-500" />
                                                            <span className="text-xs text-yellow-600">No GST Info</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {getApprovalStatusDisplay(debitNote)}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getSyncStatusBadge(debitNote.sync_status)}`}>
                                                    {debitNote.sync_status}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                <div className="flex gap-2">
                                                    <button
                                                        onClick={() => handleEdit(debitNote)}
                                                        disabled={debitNote.sync_status === 'synced' || !canEdit(debitNote)}
                                                        className={`${(debitNote.sync_status === 'synced' || !canEdit(debitNote))
                                                            ? 'text-gray-400 cursor-not-allowed'
                                                            : 'text-blue-600 hover:text-blue-900'}`}
                                                        title={
                                                            debitNote.sync_status === 'synced'
                                                                ? "Cannot edit synced debit note"
                                                                : !canEdit(debitNote)
                                                                    ? "Cannot edit - approval required"
                                                                    : "Edit"
                                                        }
                                                    >
                                                        <Edit2 size={16} />
                                                    </button>
                                                    <button
                                                        onClick={() => handleSync(debitNote.id)}
                                                        disabled={debitNote.sync_status === 'synced' || !canSync(debitNote)}
                                                        className={`${(debitNote.sync_status === 'synced' || !canSync(debitNote))
                                                            ? 'text-gray-400 cursor-not-allowed'
                                                            : 'text-green-600 hover:text-green-900'}`}
                                                        title={
                                                            debitNote.sync_status === 'synced'
                                                                ? "Already synced to Zoho"
                                                                : !canSync(debitNote)
                                                                    ? "Cannot sync - approval required"
                                                                    : "Sync to Zoho"
                                                        }
                                                    >
                                                        <RefreshCcw size={16} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}
            <div className="mt-6 flex justify-between items-center">
                <div className="text-sm text-gray-700">
                    Showing {(pagination.page - 1) * pagination.limit + 1} to{' '}
                    {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                        disabled={pagination.page === 1}
                        className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Previous
                    </button>
                    <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded">
                        {pagination.page} / {pagination.totalPages}
                    </span>
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                        disabled={pagination.page === pagination.totalPages}
                        className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Next
                    </button>
                </div>
            </div>

            {/* Form Modal */}
            {showForm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
                            <div>
                                <h2 className="text-xl font-semibold">
                                    {editingDebitNote ? 'Edit Vendor Debit Note' : 'Add New Vendor Debit Note'}
                                </h2>
                                {currentOrganization?.name && (
                                    <div className="flex items-center gap-2 mt-1">
                                        <Building className="w-4 h-4 text-blue-600" />
                                        <span className="text-sm text-blue-600 font-medium">{currentOrganization.name}</span>
                                    </div>
                                )}
                                {/* Add approval status warnings for editing */}
                                {editingDebitNote?.sync_status === 'synced' && (
                                    <div className="flex items-center gap-2 mt-2 px-3 py-2 bg-green-50 border border-green-200 rounded-lg">
                                        <CheckCircle2 className="w-4 h-4 text-green-600" />
                                        <span className="text-sm text-green-800 font-medium">
                                            This debit note has been synced to Zoho Books and cannot be edited
                                        </span>
                                    </div>
                                )}
                                {editingDebitNote?.approver_status === 'pending_approval' && (
                                    <div className="mt-2 flex items-center gap-2 px-3 py-2 bg-yellow-50 border border-yellow-200 rounded-lg">
                                        <Clock className="w-4 h-4 text-yellow-600" />
                                        <span className="text-sm text-yellow-800 font-medium">
                                            This debit note is pending approval and cannot be edited
                                        </span>
                                    </div>
                                )}
                                {editingDebitNote?.approver_status === 'rejected' && (
                                    <div className="mt-2 flex items-center gap-2 px-3 py-2 bg-red-50 border border-red-200 rounded-lg">
                                        <XCircle className="w-4 h-4 text-red-600" />
                                        <span className="text-sm text-red-800 font-medium">
                                            This debit note has been rejected and cannot be edited
                                        </span>
                                    </div>
                                )}
                                {isLoadingVendor && (
                                    <span className="text-sm text-blue-600">Loading vendor data...</span>
                                )}
                                {formData.gst_no && (
                                    <div className="mt-1 text-sm text-gray-600">
                                        Vendor State: {getStateFromGST(formData.gst_no)} |
                                        Transaction: <span className={getTransactionType(formData.gst_no, 'TN').color}>
                                            {getTransactionType(formData.gst_no, 'TN').type} ({getTransactionType(formData.gst_no, 'TN').taxType})
                                        </span>
                                    </div>
                                )}
                            </div>
                            <button
                                onClick={() => {
                                    setShowForm(false);
                                    setEditingDebitNote(null);
                                    resetForm();
                                }}
                                className="text-gray-400 hover:text-gray-600"
                            >
                                <X size={24} />
                            </button>
                        </div>

                        <form onSubmit={handleSubmit} className="p-6 space-y-6">
                            {/* Basic Information */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="relative">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Vendor Name *
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        value={formData.vendor_name}
                                        onChange={(e) => {
                                            setFormData({ ...formData, vendor_name: e.target.value });
                                            if (e.target.value.length >= 2) {
                                                searchVendors(e.target.value);
                                                setShowVendorSuggestions(true);
                                            } else {
                                                setShowVendorSuggestions(false);
                                            }
                                        }}
                                        onFocus={() => {
                                            if (vendorSuggestions.length > 0) {
                                                setShowVendorSuggestions(true);
                                            }
                                        }}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Type to search vendors..."
                                    />

                                    {/* Vendor Suggestions Dropdown */}
                                    {showVendorSuggestions && vendorSuggestions.length > 0 && (
                                        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                                            {vendorSuggestions.map((vendor) => {
                                                const vendorState = getStateFromGST(vendor.gst_no);
                                                const transactionInfo = getTransactionType(vendor.gst_no, 'TN');

                                                return (
                                                    <div
                                                        key={vendor.vendor_id}
                                                        onClick={() => handleVendorSelect(vendor)}
                                                        className="px-3 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                                                    >
                                                        <div className="font-medium text-gray-900">{vendor.vendor_name}</div>
                                                        <div className="text-xs text-gray-500">
                                                            ID: {vendor.vendor_id} | GST: {vendor.gst_no || 'N/A'}
                                                            {vendor.gst_no && (
                                                                <span className={`ml-2 ${transactionInfo.color}`}>
                                                                    {vendorState} ({transactionInfo.taxType})
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Vendor ID *
                                        {formData.vendor_id && (
                                            <CheckCircle2 size={16} className="inline ml-1 text-green-500" />
                                        )}
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        value={formData.vendor_id}
                                        onChange={(e) => {
                                            console.log('🔄 Vendor ID manually changed:', e.target.value);
                                            setFormData({ ...formData, vendor_id: e.target.value });
                                        }}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Auto-filled when vendor selected"
                                    />
                                </div>

                                {/* Debit Note Reason */}
                                <div className="md:col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Reason for Debit Note *
                                    </label>
                                    <select
                                        required
                                        value={formData.reason}
                                        onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    >
                                        <option value="price_adjustment">Price Adjustment</option>
                                        <option value="additional_charges">Additional Charges</option>
                                        <option value="penalty">Penalty</option>
                                        <option value="quantity_adjustment">Quantity Adjustment</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>

                                {/* Bill Information Section */}
                                <div className="md:col-span-2">
                                    <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                                        <div className="flex justify-between items-center mb-3">
                                            <h3 className="text-sm font-medium text-gray-700">Bill Information</h3>
                                            {formData.vendor_id && (
                                                <button
                                                    type="button"
                                                    onClick={() => setShowBillSelector(true)}
                                                    className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1"
                                                >
                                                    <FileText size={16} />
                                                    Select from Bills
                                                </button>
                                            )}
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Bill Number *
                                                </label>
                                                <input
                                                    type="text"
                                                    required
                                                    value={formData.bill_number}
                                                    onChange={(e) => setFormData({ ...formData, bill_number: e.target.value })}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Bill Date *
                                                </label>
                                                <input
                                                    type="date"
                                                    required
                                                    value={formData.bill_date}
                                                    onChange={(e) => setFormData({ ...formData, bill_date: e.target.value })}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Debit Note Amount *
                                                </label>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    required
                                                    value={formData.debit_note_amount}
                                                    onChange={(e) => setFormData({ ...formData, debit_note_amount: e.target.value })}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                />
                                            </div>
                                        </div>

                                        {/* Show selected bill info */}
                                        {formData.selected_bill && (
                                            <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                                                <div className="flex items-center gap-2 text-sm text-green-800">
                                                    <CheckCircle2 size={16} />
                                                    <span className="font-medium">Linked to Bill:</span>
                                                    <span>{formData.selected_bill.bill_number}</span>
                                                    <span className="text-green-600">({formData.selected_bill.bill_id})</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Reference Number
                                    </label>
                                    <input
                                        type="text"
                                        value={formData.reference_number}
                                        onChange={(e) => setFormData({ ...formData, reference_number: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Vendor Debit Number
                                    </label>
                                    <input
                                        type="text"
                                        value={formData.vendor_debit_number}
                                        onChange={(e) => setFormData({ ...formData, vendor_debit_number: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                            </div>

                            {/* Tax Information */}
                            <div className="border-t pt-6">
                                <h3 className="text-lg font-medium text-gray-900 mb-4">Tax Information</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            GST Number
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.gst_no}
                                            onChange={(e) => setFormData({ ...formData, gst_no: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            placeholder="Auto-filled from vendor"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            GST Treatment
                                        </label>
                                        <select
                                            value={formData.gst_treatment}
                                            onChange={(e) => setFormData({ ...formData, gst_treatment: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        >
                                            <option value="business_gst">Business GST</option>
                                            <option value="consumer">Consumer</option>
                                            <option value="overseas">Overseas</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Tax Treatment
                                        </label>
                                        <select
                                            value={formData.tax_treatment}
                                            onChange={(e) => setFormData({ ...formData, tax_treatment: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        >
                                            <option value="vat_registered">VAT Registered</option>
                                            <option value="vat_not_registered">VAT Not Registered</option>
                                            <option value="overseas">Overseas</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Source of Supply (Organization)
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.source_of_supply}
                                            onChange={(e) => setFormData({ ...formData, source_of_supply: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Destination of Supply (Vendor)
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.destination_of_supply}
                                            onChange={(e) => setFormData({ ...formData, destination_of_supply: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            placeholder="Auto-filled from vendor GST"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Place of Supply
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.place_of_supply}
                                            onChange={(e) => setFormData({ ...formData, place_of_supply: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Line Items */}
                            <div className="border-t pt-6">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="text-lg font-medium text-gray-900">Line Items</h3>
                                    <button
                                        type="button"
                                        onClick={addLineItem}
                                        className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
                                    >
                                        <Plus size={16} />
                                        Add Item
                                    </button>
                                </div>

                                <div className="space-y-4">
                                    {formData.line_items.map((item, index) => (
                                        <div key={index} className="border border-gray-200 rounded-lg p-4">
                                            <div className="flex justify-between items-center mb-3">
                                                <h4 className="font-medium text-gray-900">Item {index + 1}</h4>
                                                {formData.line_items.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeLineItem(index)}
                                                        className="text-red-600 hover:text-red-800"
                                                    >
                                                        <X size={16} />
                                                    </button>
                                                )}
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                                                <div className="lg:col-span-2">
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Item Name *
                                                    </label>
                                                    <input
                                                        type="text"
                                                        required
                                                        value={item.name}
                                                        onChange={(e) => updateLineItem(index, 'name', e.target.value)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div className="lg:col-span-2">
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Description
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={item.description}
                                                        onChange={(e) => updateLineItem(index, 'description', e.target.value)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        HSN/SAC
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={item.hsn_or_sac}
                                                        onChange={(e) => updateLineItem(index, 'hsn_or_sac', e.target.value)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Quantity *
                                                    </label>
                                                    <input
                                                        type="number"
                                                        required
                                                        min="0"
                                                        step="0.01"
                                                        value={item.quantity}
                                                        onChange={(e) => updateLineItem(index, 'quantity', parseFloat(e.target.value) || 0)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Unit
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={item.unit}
                                                        onChange={(e) => updateLineItem(index, 'unit', e.target.value)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Rate *
                                                    </label>
                                                    <input
                                                        type="number"
                                                        required
                                                        min="0"
                                                        step="0.01"
                                                        value={item.rate}
                                                        onChange={(e) => updateLineItem(index, 'rate', parseFloat(e.target.value) || 0)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>
                                            </div>

                                            {/* Tax Information for Line Item */}
                                            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3 pt-3 border-t border-gray-100">
                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        CGST Rate (%)
                                                    </label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        step="0.01"
                                                        value={item.cgst_rate}
                                                        onChange={(e) => updateLineItem(index, 'cgst_rate', parseFloat(e.target.value) || 0)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        SGST Rate (%)
                                                    </label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        step="0.01"
                                                        value={item.sgst_rate}
                                                        onChange={(e) => updateLineItem(index, 'sgst_rate', parseFloat(e.target.value) || 0)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        IGST Rate (%)
                                                    </label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        step="0.01"
                                                        value={item.igst_rate}
                                                        onChange={(e) => updateLineItem(index, 'igst_rate', parseFloat(e.target.value) || 0)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>
                                            </div>

                                            {/* Line Item Total */}
                                            <div className="mt-3 pt-3 border-t border-gray-100">
                                                <div className="flex justify-between items-center">
                                                    <span className="text-sm font-medium text-gray-700">
                                                        Subtotal: ₹ {((item.quantity || 0) * (item.rate || 0)).toFixed(2)}
                                                    </span>
                                                    <span className="text-sm font-medium text-gray-900">
                                                        Total: ₹ {calculateLineItemTotal(item).toFixed(2)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Grand Total */}
                                <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                                    <div className="flex justify-between items-center">
                                        <span className="text-lg font-medium text-gray-900">Grand Total:</span>
                                        <span className="text-lg font-bold text-blue-600">
                                            ₹ {formData.line_items.reduce((total, item) => total + calculateLineItemTotal(item), 0).toFixed(2)}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Additional Information */}
                            <div className="border-t pt-6">
                                <h3 className="text-lg font-medium text-gray-900 mb-4">Additional Information</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Currency ID
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.currency_id}
                                            onChange={(e) => setFormData({ ...formData, currency_id: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Exchange Rate
                                        </label>
                                        <input
                                            type="number"
                                            step="0.0001"
                                            value={formData.exchange_rate}
                                            onChange={(e) => setFormData({ ...formData, exchange_rate: parseFloat(e.target.value) || 1 })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div className="flex items-center space-x-6">
                                        <label className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={formData.is_inclusive_tax}
                                                onChange={(e) => setFormData({ ...formData, is_inclusive_tax: e.target.checked })}
                                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">Inclusive Tax</span>
                                        </label>

                                        <label className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={formData.autoSync}
                                                onChange={(e) => setFormData({ ...formData, autoSync: e.target.checked })}
                                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">Auto Sync to Zoho</span>
                                        </label>
                                    </div>

                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Notes
                                        </label>
                                        <textarea
                                            rows={3}
                                            value={formData.notes}
                                            onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            placeholder="Additional notes about this vendor debit note..."
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div className="border-t pt-6 flex justify-end gap-3">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowForm(false);
                                        setEditingDebitNote(null);
                                        resetForm();
                                    }}
                                    className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                >
                                    {editingDebitNote?.sync_status === 'synced' ? 'Close' : 'Cancel'}
                                </button>
                                {editingDebitNote?.sync_status !== 'synced' && (
                                    <button
                                        type="submit"
                                        disabled={isLoading || isLoadingVendor}
                                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        <Save size={16} />
                                        {isLoading ? 'Saving...' : editingDebitNote ? 'Update Debit Note' : 'Create Debit Note'}
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Bill Selector Modal */}
            {showBillSelector && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg max-w-4xl w-full max-h-[80vh] overflow-hidden">
                        <div className="px-6 py-4 border-b border-gray-200">
                            <div className="flex justify-between items-center">
                                <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                                    <FileText className="w-5 h-5 text-blue-600" />
                                    Select Bill for {formData.vendor_name}
                                </h3>
                                <button
                                    onClick={() => setShowBillSelector(false)}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <X size={24} />
                                </button>
                            </div>
                        </div>

                        <div className="p-6 overflow-y-auto max-h-[60vh]">
                            {isLoadingBills ? (
                                <div className="flex items-center justify-center py-8">
                                    <RefreshCcw className="w-8 h-8 text-blue-600 animate-spin" />
                                    <span className="ml-2 text-gray-600">Loading bills...</span>
                                </div>
                            ) : vendorBills.length === 0 ? (
                                <div className="text-center py-8">
                                    <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                                    <p className="text-gray-500 mb-2">No bills found for this vendor</p>
                                    <p className="text-sm text-gray-400">You can still create a debit note by entering bill details manually</p>
                                </div>
                            ) : (
                                <div className="space-y-3">
                                    <div className="text-sm text-gray-600 mb-4">
                                        Select a bill to link with this vendor debit note:
                                    </div>
                                    {vendorBills.map((bill) => (
                                        <div
                                            key={bill.bill_id}
                                            className={`border rounded-lg p-4 cursor-pointer transition-all hover:shadow-md ${formData.zoho_bill_id === bill.bill_id
                                                ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-200'
                                                : 'border-gray-200 hover:border-blue-300 hover:bg-gray-50'
                                                }`}
                                            onClick={() => handleBillSelect(bill)}
                                        >
                                            <div className="flex items-center justify-between">
                                                <div className="flex-1">
                                                    <div className="flex items-center gap-3">
                                                        <FileText className="w-5 h-5 text-gray-400" />
                                                        <div>
                                                            <h4 className="font-medium text-gray-900">{bill.bill_number}</h4>
                                                            <p className="text-sm text-gray-500">ID: {bill.bill_id}</p>
                                                        </div>
                                                    </div>
                                                    <div className="mt-2 flex gap-6 text-sm text-gray-600">
                                                        <div className="flex items-center gap-1">
                                                            <Calendar className="w-4 h-4" />
                                                            <span>{new Date(bill.date).toLocaleDateString()}</span>
                                                        </div>
                                                        <span>Total: ₹ {parseFloat(bill.total || 0).toFixed(2)}</span>
                                                        <span>Balance: ₹ {parseFloat(bill.balance || 0).toFixed(2)}</span>
                                                        <span className={`px-2 py-1 rounded text-xs ${bill.status === 'paid' ? 'bg-green-100 text-green-800' :
                                                            bill.status === 'overdue' ? 'bg-red-100 text-red-800' :
                                                                'bg-yellow-100 text-yellow-800'
                                                            }`}>
                                                            {bill.status}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    {formData.zoho_bill_id === bill.bill_id ? (
                                                        <div className="flex items-center gap-2">
                                                            <CheckCircle2 className="w-5 h-5 text-green-600" />
                                                            <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full font-medium">
                                                                Selected
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <div className="text-blue-600 hover:text-blue-800">
                                                            <span className="text-xs bg-blue-100 hover:bg-blue-200 px-3 py-1 rounded-full font-medium transition-colors">
                                                                Select
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
                            <div className="flex justify-between items-center">
                                <div className="text-sm text-gray-600">
                                    {vendorBills.length > 0 && (
                                        <span>{vendorBills.length} bill{vendorBills.length !== 1 ? 's' : ''} available</span>
                                    )}
                                </div>
                                <div className="flex gap-3">
                                    <button
                                        onClick={() => formData.vendor_id && fetchVendorBills(formData.vendor_id)}
                                        disabled={isLoadingBills || !formData.vendor_id}
                                        className="flex items-center gap-2 px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
                                    >
                                        <RefreshCcw className={`w-4 h-4 ${isLoadingBills ? 'animate-spin' : ''}`} />
                                        Refresh
                                    </button>
                                    <button
                                        onClick={() => setShowBillSelector(false)}
                                        className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VendorCreditManagement;